(function () {
  var MOBILE_HIDE_TARGETS = {
    ids: ['google-merchantwidget-iframe-wrapper', 'shopify-section-back_top'],
    classes: ['hs-sticky-checkout-bar']
  };
  var REQUEST_TIMEOUT_MS = 10000;
  var TRACKING_TIMEOUT_MS = 1200;
  var hiddenPopupState = new Map();

  function isMobileViewport() {
    if (window.matchMedia) return window.matchMedia('(max-width: 768px)').matches;
    return window.innerWidth <= 768;
  }

  function hideThirdPartyPopups() {
    if (!isMobileViewport()) return;
    var nodes = [];
    (MOBILE_HIDE_TARGETS.ids || []).forEach(function (id) {
      var node = document.getElementById(id);
      if (node) nodes.push(node);
    });
    (MOBILE_HIDE_TARGETS.classes || []).forEach(function (className) {
      Array.prototype.forEach.call(document.getElementsByClassName(className), function (node) {
        if (nodes.indexOf(node) === -1) nodes.push(node);
      });
    });
    nodes.forEach(function (node) {
      if (!hiddenPopupState.has(node)) {
        hiddenPopupState.set(node, {
          display: node.style.getPropertyValue('display'),
          displayPriority: node.style.getPropertyPriority('display'),
          visibility: node.style.getPropertyValue('visibility'),
          visibilityPriority: node.style.getPropertyPriority('visibility'),
          hadAriaHidden: node.hasAttribute('aria-hidden'),
          ariaHidden: node.getAttribute('aria-hidden')
        });
      }
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('visibility', 'hidden', 'important');
      node.setAttribute('aria-hidden', 'true');
    });
  }

  function restoreThirdPartyPopups() {
    hiddenPopupState.forEach(function (previous, node) {
      if (previous.display) node.style.setProperty('display', previous.display, previous.displayPriority || '');
      else node.style.removeProperty('display');
      if (previous.visibility) node.style.setProperty('visibility', previous.visibility, previous.visibilityPriority || '');
      else node.style.removeProperty('visibility');
      if (previous.hadAriaHidden) node.setAttribute('aria-hidden', previous.ariaHidden || 'true');
      else node.removeAttribute('aria-hidden');
    });
    hiddenPopupState.clear();
  }

  function joinUrl(base, path) {
    if (!path) return base || '';
    if (!base) return path;
    return String(base).replace(/\/+$/, '') + '/' + String(path).replace(/^\/+/, '');
  }

  function uniqueStrings(items) {
    var seen = Object.create(null);
    return (items || []).map(function (item) {
      return String(item === undefined || item === null ? '' : item).trim();
    }).filter(function (item) {
      var key = item.toLowerCase();
      if (!item || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function moveOtherToEnd(items) {
    var regular = [];
    var other = [];
    uniqueStrings(items).forEach(function (item) {
      if (item.toLowerCase() === 'other') other.push(item);
      else regular.push(item);
    });
    if (!other.length) other.push('Other');
    return regular.concat(other);
  }

  function unwrapPayload(payload) {
    if (!payload || typeof payload !== 'object') return payload;
    if (payload.data !== undefined && payload.data !== null) return payload.data;
    return payload;
  }

  function extractPayloadArray(payload) {
    if (Array.isArray(payload)) return payload;
    if (!payload || typeof payload !== 'object') return [];
    var keys = ['list', 'items', 'rows', 'records', 'results', 'values', 'vehicles', 'rides', 'years', 'makes', 'models'];
    for (var i = 0; i < keys.length; i += 1) {
      if (Array.isArray(payload[keys[i]])) return payload[keys[i]];
    }
    return [];
  }

  function readStringValue(item, keys) {
    if (typeof item === 'string' || typeof item === 'number') return String(item).trim();
    if (!item || typeof item !== 'object') return '';
    for (var i = 0; i < keys.length; i += 1) {
      var value = item[keys[i]];
      if (value !== undefined && value !== null && String(value).trim()) return String(value).trim();
    }
    return '';
  }

  function normalizeStringList(payload, keys) {
    var source = unwrapPayload(payload);
    var list = extractPayloadArray(source);
    if (!list.length && source && typeof source === 'object' && !Array.isArray(source)) {
      list = Object.keys(source);
    }
    return uniqueStrings(list.map(function (item) {
      return readStringValue(item, keys);
    }));
  }

  function normalizeModelList(payload) {
    return moveOtherToEnd(normalizeStringList(payload, ['model', 'name', 'label', 'value', 'text']));
  }

  function safeParse(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function isTruthyFlag(value) {
    if (value === true || value === 1) return true;
    if (value === false || value === 0 || value === undefined || value === null) return false;
    var normalized = String(value).trim().toLowerCase();
    return normalized === '1' || normalized === 'true' || normalized === 'yes';
  }

  function resolveIsCurrent(item) {
    if (!item || typeof item !== 'object') return false;
    return ['isCurrent', 'is_current', 'current', 'currentType', 'current_type'].some(function (key) {
      return isTruthyFlag(item[key]);
    });
  }

  function normalizeEmailBinding(value) {
    var normalized = String(value || '').trim().toLowerCase();
    return normalized === 'bound' || normalized === 'unbound' ? normalized : '';
  }

  function isVisibleEntry(entry) {
    if (!entry || typeof entry.getBoundingClientRect !== 'function') return false;
    var style = window.getComputedStyle ? window.getComputedStyle(entry) : null;
    if (style && (style.display === 'none' || style.visibility === 'hidden')) return false;
    var rect = entry.getBoundingClientRect();
    return rect.width > 0 && rect.right > 0 && rect.left < window.innerWidth && rect.bottom >= 0 && rect.top < window.innerHeight;
  }

  function setup(root) {
    if (!root || root.getAttribute('data-mobile-ride-inited') === '1') return;
    if (root.__kmMobileRideCriticalCleanup) root.__kmMobileRideCriticalCleanup();
    root.__kmMobileRideCriticalReady = true;
    root.setAttribute('data-mobile-ride-inited', '1');

    var openButton = root.querySelector('[data-mobile-ride-open]');
    var sheet = root.querySelector('[data-mobile-ride-sheet]');
    var closeButtons = root.querySelectorAll('[data-mobile-ride-close]');
    var triggerLabel = root.querySelector('[data-mobile-ride-label]');
    var keywordInput = root.querySelector('[data-mobile-ride-keyword]');
    var searchButton = root.querySelector('[data-mobile-ride-search]');
    var garageLoading = root.querySelector('[data-mobile-garage-loading]');
    var savedStage = root.querySelector('[data-mobile-stage="saved"]');
    var savedList = root.querySelector('[data-mobile-saved-list]');
    var primaryGuide = root.querySelector('[data-mobile-primary-guide]');
    var primaryOpen = root.querySelector('[data-mobile-primary-open]');
    var primaryChange = root.querySelector('[data-mobile-primary-change]');
    var primaryStage = root.querySelector('[data-mobile-primary-stage]');
    var primaryList = root.querySelector('[data-mobile-primary-list]');
    var primarySubscriptionForm = root.querySelector('[data-mobile-primary-subscription-form]');
    var primaryEmail = root.querySelector('[data-mobile-primary-email]');
    var primarySuccess = root.querySelector('[data-mobile-primary-success]');
    var primaryDiscount = root.querySelector('[data-mobile-primary-discount]');
    var primaryDiscountCode = root.querySelector('[data-mobile-primary-discount-code]');
    var primaryDiscountCopy = root.querySelector('[data-mobile-primary-discount-copy]');
    var primaryError = root.querySelector('[data-mobile-primary-error]');
    var primaryOffer = root.querySelector('[data-mobile-primary-offer]');
    var primarySave = root.querySelector('[data-mobile-primary-save]');
    var primarySaveLabel = root.querySelector('[data-mobile-primary-save-label]');
    var primarySpinner = root.querySelector('[data-mobile-primary-spinner]');
    var primarySkip = root.querySelector('[data-mobile-primary-skip]');
    var addButton = root.querySelector('[data-mobile-show-add]');
    var pickerStage = root.querySelector('[data-mobile-picker-stage]');
    var stageTitle = root.querySelector('[data-mobile-stage-title]');
    var backButton = root.querySelector('[data-mobile-back-to-saved]');
    var shopWithoutRideWrap = root.querySelector('.mobile-ride-sheet__shop-without-wrap');
    var shopWithoutRideLink = root.querySelector('[data-mobile-shop-without]');
    var shopWithoutRideTooltip = root.querySelector('[data-mobile-shop-without-tooltip]');
    var shopWithoutRideTooltipTrigger = root.querySelector('[data-mobile-shop-without-tooltip-trigger]');
    var shopWithoutRideTooltipPanel = root.querySelector('[data-mobile-shop-without-tooltip-panel]');
    var stepButtons = root.querySelectorAll('[data-mobile-step]');
    var currentSummary = root.querySelector('[data-mobile-current-summary]');
    var currentValue = root.querySelector('[data-mobile-current-value]');
    var fitmentSummary = root.querySelector('[data-mobile-fitment-summary]');
    var fitmentPrefix = root.querySelector('[data-mobile-fitment-prefix]');
    var choiceStage = root.querySelector('[data-mobile-choice-stage]');
    var filterInput = root.querySelector('[data-mobile-option-filter]');
    var filterLabel = root.querySelector('[data-mobile-filter-label]');
    var optionsWrap = root.querySelector('[data-mobile-options]');
    var incompleteAction = root.querySelector('[data-mobile-incomplete-action]');
    var manualWrap = root.querySelector('[data-mobile-manual]');
    var manualLabel = root.querySelector('[data-mobile-manual-label]');
    var manualInput = root.querySelector('[data-mobile-manual-input]');
    var manualError = root.querySelector('[data-mobile-manual-error]');
    var manualContinue = root.querySelector('[data-mobile-manual-continue]');
    var completeWrap = root.querySelector('[data-mobile-complete]');
    var fitmentLabel = root.querySelector('[data-mobile-fitment-label]');
    var confirmedRideLabel = root.querySelector('[data-mobile-confirmed-ride]');
    var footer = root.querySelector('[data-mobile-footer]');
    var subscribedComplete = root.querySelector('[data-mobile-subscribed-complete]');
    var viewItemsButton = root.querySelector('[data-mobile-view-items]');
    var viewItemsLabel = root.querySelector('[data-mobile-view-items-label]');
    var countSpinner = root.querySelector('[data-mobile-count-spinner]');
    var subscriptionComplete = root.querySelector('[data-mobile-subscription-complete]');
    var subscriptionForm = root.querySelector('[data-mobile-subscription-form]');
    var subscriptionEmail = root.querySelector('[data-mobile-subscription-email]');
    var subscriptionError = root.querySelector('[data-mobile-subscription-error]');
    var subscribeAction = root.querySelector('[data-mobile-subscribe-action]');
    var subscribeButton = root.querySelector('[data-mobile-subscribe-submit]');
    var subscribeLabel = root.querySelector('[data-mobile-subscribe-label]');
    var subscribeSpinner = root.querySelector('[data-mobile-subscribe-spinner]');
    var notNowLink = root.querySelector('[data-mobile-not-now]');
    var signInLink = root.querySelector('.mobile-ride-sheet__signin');
    if (!openButton || !sheet || !savedStage || !pickerStage || !optionsWrap) return;

    var isLoggedIn = root.getAttribute('data-customer-logged-in') === 'true';
    var customerId = String(root.getAttribute('data-customer-id') || '').trim();
    var customerEmail = String(root.getAttribute('data-customer-email') || '').trim();
    var storageKey = root.getAttribute('data-garage-storage') || 'km_garage_rides';
    var emailBindingStorageKey = 'km_garage_email_binding';
    var subscribedEmailStorageKey = 'km_subscribe_email';
    var confirmedSubscribedEmailStorageKey = 'km_subscription_confirmed_email';
    var primaryEmailStorageKey = 'km_product_subscription_submitted_email';
    var searchNoticeStorageKey = 'km_search_subscription_notice';
    var shopWithoutRideKey = 'km_shop_without_ride';
    var baseUrl = root.getAttribute('data-garage-base-url') || '';
    var garageUrl = joinUrl(baseUrl, root.getAttribute('data-garage-api') || '');
    var yearUrl = joinUrl(baseUrl, root.getAttribute('data-ymm-year-api') || '');
    var makeUrl = joinUrl(baseUrl, root.getAttribute('data-ymm-make-api') || '');
    var modelUrl = joinUrl(baseUrl, root.getAttribute('data-ymm-model-api') || '');
    var countUrl = joinUrl(baseUrl, root.getAttribute('data-garage-count-api') || '');
    var saveUrl = joinUrl(baseUrl, root.getAttribute('data-garage-save-api') || '');
    var subscriptionUrl = joinUrl(baseUrl, root.getAttribute('data-subscription-api') || '/api/customers/subscribe-and-send-discount');
    var primarySwitchUrl = joinUrl(baseUrl, root.getAttribute('data-primary-switch-api') || '/api/vehicle/switchPrimaryVehicle');
    var updateUrl = joinUrl(baseUrl, root.getAttribute('data-garage-update-api') || '');
    var resetUrl = joinUrl(baseUrl, root.getAttribute('data-garage-reset-api') || '');
    var deleteUrl = joinUrl(baseUrl, root.getAttribute('data-garage-delete-api') || '');
    var redirectUrl = root.getAttribute('data-redirect-url') || '/search';
    var isProductDetailPage = root.getAttribute('data-page-type') === 'product';
    var externalLabelNodes = document.querySelectorAll('[data-mobile-ride-label-external]');

    function setFitCartEntry(active) {
      if (active) root.setAttribute('data-fit-cart-entry', 'true');
      else root.removeAttribute('data-fit-cart-entry');
      resetProductFitmentState();
    }

    function isProductFitCartEntry() {
      return isProductDetailPage && root.getAttribute('data-fit-cart-entry') === 'true';
    }

    function isCompleteSavedRide(ride) {
      return Boolean(ride && ride.year && ride.make && ride.model);
    }

    function hasSavedRide() {
      if (state.rides.some(isCompleteSavedRide)) return true;
      return readLocalRides().some(isCompleteSavedRide);
    }

    function getPickerTitle() {
      if (!isProductFitCartEntry()) return 'Shop for Your Ride';
      return hasSavedRide() ? 'Check Another Ride' : 'Check My Ride';
    }

    function getProductFitmentContext() {
      if (!isProductFitCartEntry()) return null;
      var nodes = document.querySelectorAll('[data-fit-cart-info][data-product-id]');
      var fallback = null;
      for (var i = 0; i < nodes.length; i += 1) {
        var fitCartRoot = nodes[i];
        var section = fitCartRoot.closest('.product-section');
        if (!section || String(section.getAttribute('data-modal') || '').toLowerCase() === 'true') continue;
        var context = {
          root: fitCartRoot,
          section: section,
          productId: String(fitCartRoot.getAttribute('data-product-id') || '').trim(),
          apiUrl: fitCartRoot.getAttribute('data-product-api') || '/api/product/productVehicle'
        };
        if (!fallback) fallback = context;
        if (fitCartRoot.getAttribute('data-fit-cart-visible') === 'true') return context;
      }
      return fallback;
    }

    function resolveCurrentProductSku(context) {
      if (!context || !context.section) return '';
      var section = context.section;
      var variantId = '';
      var variantInput = section.querySelector('[data-product-select]');
      if (variantInput) variantId = String(variantInput.value || '').trim();
      if (!variantId) {
        var hiddenIdInput = section.querySelector('form.product-single__form [name="id"]');
        variantId = String(hiddenIdInput && hiddenIdInput.value || '').trim();
      }
      var variantsNode = section.querySelector('[data-variant-json]');
      var variants = safeParse(variantsNode && variantsNode.textContent);
      if (!Array.isArray(variants) || !variants.length) return '';
      var matched = variants.find(function (item) {
        return String(item && item.id || '').trim() === variantId;
      }) || variants[0];
      return String(matched && matched.sku || '').trim();
    }

    function normalizeProductFitmentResult(payload) {
      if (payload === undefined || payload === null) return '';
      if (typeof payload === 'number' || typeof payload === 'string') {
        return String(payload).trim();
      }
      if (Array.isArray(payload)) {
        return payload.length ? normalizeProductFitmentResult(payload[0]) : '';
      }
      if (typeof payload !== 'object') return '';
      if (payload.data !== undefined && payload.data !== payload) {
        var dataStatus = normalizeProductFitmentResult(payload.data);
        if (dataStatus) return dataStatus;
      }
      if (payload.result !== undefined && payload.result !== payload) {
        var resultStatus = normalizeProductFitmentResult(payload.result);
        if (resultStatus) return resultStatus;
      }
      var candidates = [payload.status, payload.fitmentStatus, payload.fitment_status, payload.code];
      for (var i = 0; i < candidates.length; i += 1) {
        var value = String(candidates[i] === undefined || candidates[i] === null ? '' : candidates[i]).trim();
        if (value) return value;
      }
      return '';
    }

    function buildProductFitmentKey(ride) {
      if (!ride || ride.isCustom) return '';
      var rideKey = rideYmmIdentity(ride);
      var context = getProductFitmentContext();
      if (!rideKey || !context || !context.productId) return '';
      return [rideKey, context.productId, resolveCurrentProductSku(context)].join('|');
    }

    function fetchProductFitment(ride) {
      var context = getProductFitmentContext();
      var key = buildProductFitmentKey(ride);
      if (!context || !key) return Promise.resolve('unknown');
      var apiUrl = /^https?:\/\//i.test(context.apiUrl)
        ? context.apiUrl
        : joinUrl(baseUrl, context.apiUrl);
      var params = new URLSearchParams();
      params.set('year', String(ride.year || ''));
      params.set('make', String(ride.make || ''));
      params.set('model', String(ride.model || ''));
      params.set('productId', context.productId);
      var sku = resolveCurrentProductSku(context);
      if (sku) params.set('sku', sku);
      var requestUrl = apiUrl + (apiUrl.indexOf('?') === -1 ? '?' : '&') + params.toString();
      return fetchWithTimeout(requestUrl, {
        method: 'GET',
        credentials: 'include'
      }, REQUEST_TIMEOUT_MS).then(function (response) {
        if (!response.ok) throw new Error('Failed to fetch product fitment');
        return response.json();
      }).then(function (payload) {
        var status = normalizeProductFitmentResult(payload);
        if (status === '2') return 'fit';
        if (status === '1') return 'unfit';
        return 'unknown';
      }).catch(function () {
        return 'unknown';
      });
    }

    function resetProductFitmentState() {
      state.productFitmentStatus = 'idle';
      state.productFitmentKey = '';
    }

    function getCurrentProductFitmentStatus(ride) {
      if (!isProductFitCartEntry()) return '';
      var key = buildProductFitmentKey(ride);
      if (!key || state.productFitmentKey !== key) return '';
      return state.productFitmentStatus;
    }

    function isDirectViewCompletion() {
      return [
        'subscribed',
        'product-pending',
        'product-fit-saved',
        'product-unfit'
      ].indexOf(state.completionMode) !== -1;
    }

    function shouldReloadProductAfterRideSave() {
      return isProductFitCartEntry();
    }

    function normalizeCustomerTags(tags) {
      var list = Array.isArray(tags) ? tags : [tags];
      var seen = Object.create(null);
      return list.map(function (tag) {
        return String(tag || '').trim();
      }).filter(function (tag) {
        if (!tag || seen[tag]) return false;
        seen[tag] = true;
        return true;
      });
    }

    function addCustomerTag(tag, email) {
      if (!window.KMCustomerTags || typeof window.KMCustomerTags.add !== 'function') {
        return Promise.resolve(false);
      }
      return window.KMCustomerTags.add(tag, {
        customerId: isLoggedIn ? customerId : '',
        email: String(email || (isLoggedIn ? customerEmail : '') || '').trim()
      });
    }

    function addCustomerTags(tags, email) {
      var normalizedTags = normalizeCustomerTags(tags);
      if (!normalizedTags.length) return Promise.resolve(false);
      try {
        return Promise.resolve(addCustomerTag(normalizedTags, email)).catch(function () {
          return false;
        });
      } catch (error) {
        return Promise.resolve(false);
      }
    }

    function getGarageBusinessTag(methodName, options) {
      var customerTags = window.KMCustomerTags;
      if (!customerTags || typeof customerTags[methodName] !== 'function') return '';
      return String(customerTags[methodName](options) || '').trim();
    }

    function addGarageBusinessTag(methodName, options, email) {
      var tag = getGarageBusinessTag(methodName, options);
      return tag ? addCustomerTag(tag, email) : Promise.resolve(false);
    }

    function beginGarageTagFlow(promptState) {
      if (
        window.KMCustomerTags &&
        typeof window.KMCustomerTags.beginGarageFlow === 'function'
      ) {
        window.KMCustomerTags.beginGarageFlow(promptState);
      }
    }

    function endGarageTagFlow() {
      if (
        window.KMCustomerTags &&
        typeof window.KMCustomerTags.endGarageFlow === 'function'
      ) {
        window.KMCustomerTags.endGarageFlow();
      }
    }

    function waitForCustomerTag(promise) {
      return withTimeout(Promise.resolve(promise), 800).catch(function () {
        return false;
      });
    }

    function addGarageEntryClickCustomerTag(event) {
      if (!event || event.isTrusted !== true) return Promise.resolve(false);
      beginGarageTagFlow();
      return addGarageBusinessTag(
        'getGarageEntryClickTag',
        null,
        getSubscriptionEmail()
      );
    }

    function getGarageCarSaveCustomerTag() {
      return getGarageBusinessTag('getGarageCarSaveTag', null);
    }

    function addGarageCarSaveCustomerTag(ride) {
      return addGarageBusinessTag(
        'getGarageCarSaveTag',
        null,
        getSubscriptionEmail(ride)
      );
    }

    function addGarageSearchCustomerTag(ride) {
      var hasSavedRide = Boolean(ride && ride.year && ride.make && ride.model);
      return addGarageBusinessTag('getGarageSearchTag', {
        subscribed: isSubscribedCustomer(),
        hasSavedRide: hasSavedRide
      }, getSubscriptionEmail(ride));
    }

    sheet.__kmMobileRideOwner = root;
    root.__kmMobileRideSheet = sheet;
    sheet.setAttribute('data-customer-logged-in', isLoggedIn ? 'true' : 'false');
    sheet.setAttribute('data-mobile-current-stage', root.getAttribute('data-mobile-current-stage') || 'loading');
    sheet.setAttribute('data-mobile-completion-state', root.getAttribute('data-mobile-completion-state') || '');

    var isDestroyed = false;
    var subscriptionEmailPromptDismissed = false;

    function mountSheet() {
      /* A fixed descendant of the transformed navigation drawer is drawer-relative. */
      if (isDestroyed) return;
      if (document.body && sheet.parentNode !== document.body) document.body.appendChild(sheet);
    }

    var state = {
      garageReady: false,
      stage: 'year',
      rides: [],
      selected: { year: '', make: '', model: '', isCustom: false },
      options: { year: [], make: [], model: [] },
      optionsLoading: false,
      manualKind: '',
      filter: '',
      count: 0,
      countLoading: false,
      submitting: false,
      completionMode: '',
      productFitmentStatus: 'idle',
      productFitmentKey: '',
      primarySelectedId: '',
      primarySubmitting: false,
      primaryHydrating: false,
      primarySubscriptionConfirmed: false,
      primaryDiscountCode: '',
      primaryResultHydrated: false
    };
    var yearPromise = null;
    var makeCache = Object.create(null);
    var modelCache = Object.create(null);
    var makeRequestSequence = 0;
    var modelRequestSequence = 0;
    var countRequestSequence = 0;
    var navigationRequestSequence = 0;
    var transitionTimer = 0;
    var popupHideTimer = 0;
    var ridePromptController = null;
    var primaryHydrationSequence = 0;
    var garageRequestSucceeded = !isLoggedIn;

    function isOther(value) {
      return String(value || '').trim().toLowerCase() === 'other';
    }

    function normalizeRide(item) {
      if (!item) return null;
      var count = item.itemsCount;
      if (count === undefined || count === null || count === '') count = item.items;
      if (count === undefined || count === null || count === '') count = item.items_count;
      if (count === undefined || count === null || count === '') count = item.itemCount;
      if (count === undefined || count === null || count === '') count = item.count;
      var emailBinding = normalizeEmailBinding(item.emailBinding);
      if (!emailBinding) emailBinding = normalizeEmailBinding(item.email_binding);
      var ride = {
        id: String(item.id || item.vehicle_id || item.vehicleId || ''),
        year: String(item.year || item.vehicle_year || item.vehicleYear || ''),
        make: String(item.make || item.vehicle_make || item.vehicleMake || ''),
        model: String(item.model || item.vehicle_model || item.vehicleModel || item.trim || ''),
        itemsCount: count === undefined || count === null ? '' : count,
        isCurrent: resolveIsCurrent(item),
        primaryVehicle: resolvePrimaryVehicle(item),
        userId: String(item.userId || item.user_id || ''),
        email: String(item.email || item.other_email || ''),
        isCustom: Boolean(item.isCustom || item.is_custom || item.custom)
      };
      if (emailBinding) ride.emailBinding = emailBinding;
      return ride.year || ride.make || ride.model || ride.id ? ride : null;
    }

    function resolvePrimaryVehicle(item) {
      if (!item || typeof item !== 'object') return 0;
      var value = item.primaryVehicle;
      if (value === undefined) value = item.primary_vehicle;
      return isTruthyFlag(value) ? 1 : 0;
    }

    function rideIdentity(ride) {
      if (!ride) return '';
      if (ride.id) return 'id:' + String(ride.id);
      return rideYmmIdentity(ride);
    }

    function rideYmmIdentity(ride) {
      if (!ride) return '';
      var values = [ride.year, ride.make, ride.model].map(function (value) {
        return String(value || '').trim().toLowerCase();
      });
      return values.some(Boolean) ? 'ymm:' + values.join('|') : '';
    }

    function hasRemoteRideId(ride) {
      var id = String(ride && ride.id || '').trim();
      return Boolean(id && id.indexOf('|') === -1);
    }

    function readLocalRidesSnapshot() {
      try {
        var rawValue = localStorage.getItem(storageKey);
        if (!rawValue) return { ok: true, rides: [] };
        var value = safeParse(rawValue);
        if (!Array.isArray(value)) return { ok: false, rides: [] };
        return {
          ok: true,
          rides: ensureSingleCurrent(value.map(normalizeRide).filter(Boolean))
        };
      } catch (error) {
        return { ok: false, rides: [] };
      }
    }

    function readLocalRides() {
      return readLocalRidesSnapshot().rides;
    }

    function notifyRideStorageChange() {
      if (typeof window.CustomEvent === 'function') {
        document.dispatchEvent(new CustomEvent('km:mobile-ride-storage-change', {
          detail: { storageKey: storageKey, source: root }
        }));
      }
    }

    function writeLocalRides(rides) {
      var didWrite = false;
      try {
        localStorage.setItem(storageKey, JSON.stringify(ensureSingleCurrent(rides || [])));
        didWrite = true;
      } catch (error) {}
      if (didWrite) notifyRideStorageChange();
      return didWrite;
    }

    function ensureSingleCurrent(rides) {
      var foundCurrent = false;
      return (rides || []).map(function (ride) {
        if (!ride || !ride.isCurrent) return ride;
        if (!foundCurrent) {
          foundCurrent = true;
          return ride;
        }
        return Object.assign({}, ride, { isCurrent: false });
      });
    }

    function mergeRides(localRides, remoteRides) {
      var merged = [];
      (localRides || []).concat(remoteRides || []).forEach(function (ride) {
        var normalized = normalizeRide(ride);
        if (!normalized) return;
        var position = merged.findIndex(function (savedRide) {
          if (savedRide.id && normalized.id && savedRide.id === normalized.id) return true;
          return String(savedRide.year).toLowerCase() === String(normalized.year).toLowerCase() &&
            String(savedRide.make).toLowerCase() === String(normalized.make).toLowerCase() &&
            String(savedRide.model).toLowerCase() === String(normalized.model).toLowerCase();
        });
        if (position !== -1) {
          var existing = merged[position];
          var next = Object.assign({}, existing, normalized);
          ['id', 'year', 'make', 'model', 'itemsCount', 'userId', 'email'].forEach(function (key) {
            var incomingValue = normalized[key];
            var existingValue = existing[key];
            var incomingEmpty = incomingValue === undefined || incomingValue === null || String(incomingValue).trim() === '';
            var existingPresent = existingValue !== undefined && existingValue !== null && String(existingValue).trim() !== '';
            if (incomingEmpty && existingPresent) next[key] = existingValue;
          });
          merged[position] = next;
          return;
        }
        merged.push(normalized);
      });
      return ensureSingleCurrent(merged);
    }

    function ridesMatch(left, right) {
      if (!left || !right) return false;
      if (left.id && right.id && String(left.id) === String(right.id)) return true;
      return Boolean(rideYmmIdentity(left) && rideYmmIdentity(left) === rideYmmIdentity(right));
    }

    function replaceRidesWithRemote(remoteRides, cachedRides) {
      var remote = (remoteRides || []).map(normalizeRide).filter(Boolean);
      var cached = (cachedRides || []).map(normalizeRide).filter(Boolean);
      var resolvedCurrent = remote.find(function (ride) { return ride.isCurrent; }) ||
        cached.find(function (ride) { return ride.isCurrent; });
      if (!resolvedCurrent) return ensureSingleCurrent(remote);
      return ensureSingleCurrent(remote.map(function (ride) {
        return Object.assign({}, ride, { isCurrent: ridesMatch(ride, resolvedCurrent) });
      }));
    }

    function currentRide() {
      if (isShopWithoutRideActive()) return null;
      return state.rides.find(function (ride) { return ride.isCurrent; }) || null;
    }

    function isShopWithoutRideActive() {
      try {
        return localStorage.getItem(shopWithoutRideKey) === '1';
      } catch (error) {
        return false;
      }
    }

    function setShopWithoutRideActive(active) {
      try {
        if (active) localStorage.setItem(shopWithoutRideKey, '1');
        else localStorage.removeItem(shopWithoutRideKey);
      } catch (error) {}
    }

    function setCurrentLabel(ride) {
      var label = ride ? [ride.year, ride.make, ride.model].filter(Boolean).join(' ') : 'Select your ride';
      if (triggerLabel) triggerLabel.textContent = label;
      externalLabelNodes.forEach(function (node) {
        if (!node) return;
        if (!node.getAttribute('data-mobile-ride-default-label')) {
          node.setAttribute('data-mobile-ride-default-label', String(node.textContent || '').trim() || 'Select your ride');
        }
        node.textContent = ride ? label : node.getAttribute('data-mobile-ride-default-label');
      });
    }

    function isSubscribedCustomer() {
      if (isLoggedIn) {
        return root.getAttribute('data-customer-subscribed') === 'true';
      }
      try {
        var confirmedEmail = String(localStorage.getItem(confirmedSubscribedEmailStorageKey) || '').trim().toLowerCase();
        return Boolean(confirmedEmail);
      } catch (error) {
        return false;
      }
    }

    function getPrimaryRide() {
      return state.rides.find(function (ride) {
        return resolvePrimaryVehicle(ride) === 1;
      }) || null;
    }

    function needsPrimarySubscription() {
      if (isLoggedIn) return root.getAttribute('data-customer-subscribed') !== 'true';
      try {
        return !String(localStorage.getItem(primaryEmailStorageKey) || '').trim();
      } catch (error) {
        return true;
      }
    }

    function getKnownPrimarySubscriptionEmail() {
      if (isLoggedIn) {
        return root.getAttribute('data-customer-subscribed') === 'true'
          ? String(customerEmail || '').trim()
          : '';
      }
      try {
        return String(localStorage.getItem(primaryEmailStorageKey) || '').trim();
      } catch (error) {
        return '';
      }
    }

    function getDefaultSubscriptionEmail() {
      return !isSubscribedCustomer() ? getSubscriptionEmail() : '';
    }

    function prefillSubscriptionEmail(forceKnownEmail) {
      if (!subscriptionEmail || subscriptionEmail.value) return;
      subscriptionEmail.value = forceKnownEmail
        ? getSubscriptionEmail()
        : getDefaultSubscriptionEmail();
    }

    function syncEditableSubscriptionEmailPrompt(active) {
      if (!subscriptionEmail) return;
      if (!active) subscriptionEmailPromptDismissed = false;
      var shouldPrompt = Boolean(
        active &&
        !subscriptionEmailPromptDismissed &&
        !subscriptionEmail.disabled &&
        !subscriptionEmail.readOnly
      );
      subscriptionEmail.classList.toggle('is-subscription-email-prompting', shouldPrompt);
    }

    function dismissSubscriptionEmailPrompt() {
      if (!subscriptionEmail) return;
      subscriptionEmailPromptDismissed = true;
      subscriptionEmail.classList.remove('is-subscription-email-prompting');
    }

    function withTimeout(promise, timeoutMs, onTimeout) {
      var duration = Number(timeoutMs) || REQUEST_TIMEOUT_MS;
      return new Promise(function (resolve, reject) {
        var settled = false;
        var timer = window.setTimeout(function () {
          if (settled) return;
          settled = true;
          if (typeof onTimeout === 'function') onTimeout();
          reject(new Error('Request timed out'));
        }, duration);

        Promise.resolve(promise).then(function (value) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          resolve(value);
        }, function (error) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          reject(error);
        });
      });
    }

    function waitForGarageApi() {
      if (window.api) return Promise.resolve(window.api);
      return new Promise(function (resolve, reject) {
        var started = Date.now();
        function check() {
          if (window.api) return resolve(window.api);
          if (Date.now() - started >= REQUEST_TIMEOUT_MS) return reject(new Error('API client unavailable'));
          window.setTimeout(check, 25);
        }
        check();
      });
    }

    function normalizeApiEndpoint(url) {
      return String(url || '').replace(/^https?:\/\/api(?:test)?\.kemimoto\.com(?=\/)/i, '');
    }

    function fetchWithTimeout(url, requestOptions, timeoutMs) {
      var options = Object.assign({}, requestOptions || {});
      var method = String(options.method || 'GET').toLowerCase();
      var headers = options.headers || {};
      delete options.method;
      delete options.headers;
      var controller = typeof window.AbortController === 'function' && !options.signal
        ? new window.AbortController()
        : null;
      if (controller) options.signal = controller.signal;
      options.responseType = 'raw';
      options.skipDefaultHeaders = true;
      var request = waitForGarageApi().then(function (api) {
        if (!api || typeof api[method] !== 'function') throw new Error('Unsupported request method');
        return api[method](normalizeApiEndpoint(url), null, false, headers, options);
      });
      return withTimeout(request, timeoutMs, function () {
        if (controller) controller.abort();
      });
    }

    function fetchJson(url, params, requestOptions, timeoutMs) {
      if (!url) return Promise.reject(new Error('Missing endpoint'));
      var options = Object.assign({ credentials: 'include' }, requestOptions || {});
      var headers = options.headers || {};
      delete options.headers;
      return withTimeout(waitForGarageApi().then(function (api) {
        return api.get(normalizeApiEndpoint(url), params || null, false, headers, options);
      }), timeoutMs).then(function (payload) {
        return payload;
      });
    }

    function fetchGarage() {
      if (!isLoggedIn) return Promise.resolve([]);
      if (!garageUrl) {
        garageRequestSucceeded = false;
        return Promise.resolve([]);
      }
      return fetchJson(garageUrl, { userId: customerId, email: customerEmail }).then(function (payload) {
        if (payload && payload.code !== undefined && Number(payload.code) !== 200) {
          throw new Error(String(payload.msg || 'Unable to load rides'));
        }
        garageRequestSucceeded = true;
        var source = unwrapPayload(payload);
        var list = extractPayloadArray(source);
        return list.map(normalizeRide).filter(Boolean);
      }).catch(function () {
        garageRequestSucceeded = false;
        return [];
      });
    }

    function refreshPrimaryRidesFromApi() {
      if (!garageUrl) return Promise.reject(new Error('Missing garage endpoint'));
      return fetchJson(garageUrl, { userId: customerId, email: customerEmail }).then(function (payload) {
        if (!payload || Number(payload.code) !== 200) {
          throw new Error(String(payload && payload.msg || 'Unable to refresh rides'));
        }
        var source = unwrapPayload(payload);
        return extractPayloadArray(source).map(normalizeRide).filter(Boolean);
      });
    }

    function ensureYears() {
      if (yearPromise) {
        state.optionsLoading = true;
        render();
        return yearPromise;
      }
      var cache = window.__KM_YMM_YEAR_CACHE__ || (window.__KM_YMM_YEAR_CACHE__ = Object.create(null));
      if (Array.isArray(cache[yearUrl])) {
        state.options.year = cache[yearUrl].slice();
        state.optionsLoading = false;
        render();
        return Promise.resolve(state.options.year);
      }
      state.optionsLoading = true;
      render();
      yearPromise = fetchJson(yearUrl).then(function (payload) {
        var years = normalizeStringList(payload, ['year', 'name', 'label', 'value']).filter(function (year) {
          return /^[0-9]{4}$/.test(year);
        }).sort(function (left, right) {
          return Number(right) - Number(left);
        });
        cache[yearUrl] = years.slice();
        if (isDestroyed) return years;
        state.options.year = years;
        return years;
      }).catch(function () {
        if (isDestroyed) return [];
        state.options.year = [];
        return [];
      }).finally(function () {
        if (isDestroyed) return;
        state.optionsLoading = false;
        yearPromise = null;
        render();
      });
      return yearPromise;
    }

    function fetchMakes(year) {
      var key = String(year || '');
      if (makeCache[key]) return Promise.resolve(makeCache[key].slice());
      return fetchJson(makeUrl, { year: key }).then(function (payload) {
        var makes = moveOtherToEnd(normalizeStringList(payload, ['make', 'name', 'label', 'value']));
        makeCache[key] = makes;
        return makes.slice();
      }).catch(function () {
        makeCache[key] = ['Other'];
        return ['Other'];
      });
    }

    function fetchModels(year, make) {
      var key = String(year || '') + '||' + String(make || '').toLowerCase();
      if (modelCache[key]) return Promise.resolve(modelCache[key].slice());
      return fetchJson(modelUrl, { year: year, make: make }).then(function (payload) {
        var models = normalizeModelList(payload);
        modelCache[key] = models;
        return models.slice();
      }).catch(function () {
        modelCache[key] = ['Other'];
        return ['Other'];
      });
    }

    function buildRideFromSelection() {
      return {
        year: state.selected.year,
        make: state.selected.make,
        model: state.selected.model,
        itemsCount: state.count,
        isCurrent: true,
        isCustom: state.selected.isCustom
      };
    }

    function buildSearchUrl(ride, title) {
      var params = new URLSearchParams();
      if (ride && ride.year) params.set('year', String(ride.year));
      if (ride && ride.make) params.set('make', String(ride.make));
      if (ride && ride.model) params.set('model', String(ride.model));
      if (ride && ride.email) params.set('email', String(ride.email));
      if (String(title || '').trim()) params.set('title', String(title).trim());
      return redirectUrl + (params.toString() ? (redirectUrl.indexOf('?') === -1 ? '?' : '&') + params.toString() : '');
    }

    function getRideFromUrl() {
      var params = new URLSearchParams(window.location.search);
      return normalizeRide({
        year: params.get('year') || '',
        make: params.get('make') || '',
        model: params.get('model') || '',
        email: params.get('email') || ''
      });
    }

    function getSubscriptionEmail(ride) {
      var rideEmail = String(ride && ride.email || '').trim();
      if (rideEmail) return rideEmail;
      if (customerEmail) return customerEmail;
      if (!window.localStorage) return '';
      try {
        return String(localStorage.getItem(confirmedSubscribedEmailStorageKey) || '').trim() ||
          String(localStorage.getItem(subscribedEmailStorageKey) || '').trim();
      } catch (err) {
        return '';
      }
    }

    function queueSearchNotice(mode, ride, showSubscribeButton, customerTags) {
      if (mode !== 'request' && mode !== 'subscribe') return;
      if (!window.localStorage) return;
      try {
        var notice = {
          mode: mode === 'subscribe' ? 'subscribe' : 'request',
          email: mode === 'subscribe' ? '' : getSubscriptionEmail(ride),
          showSubscribeButton: showSubscribeButton === true,
          ride: {
            year: String(ride && ride.year || ''),
            make: String(ride && ride.make || ''),
            model: String(ride && ride.model || '')
          },
          createdAt: Date.now()
        };
        var normalizedCustomerTags = mode === 'request'
          ? normalizeCustomerTags(customerTags)
          : [];
        if (normalizedCustomerTags.length) notice.customerTags = normalizedCustomerTags;
        localStorage.setItem(searchNoticeStorageKey, JSON.stringify(notice));
      } catch (err) {}
    }

    function navigateAfterSave(ride, noticeMode, title, showSubscribeButton, options) {
      var reloadProductPage = options && typeof options.reloadProductPage === 'boolean'
        ? options.reloadProductPage
        : shouldReloadProductAfterRideSave();
      if (reloadProductPage) {
        window.location.reload();
        return;
      }
      queueSearchNotice(
        noticeMode,
        ride,
        showSubscribeButton,
        options && options.customerTags
      );
      window.location.href = buildSearchUrl(ride, title);
    }

    function syncLocalRide(ride, id) {
      setShopWithoutRideActive(false);
      var normalized = normalizeRide(Object.assign({}, ride, {
        id: String(id || ride.id || [ride.year, ride.make, ride.model].join('|')),
        isCurrent: true
      }));
      if (!normalized) return false;
      var found = false;
      state.rides = state.rides.map(function (savedRide) {
        var same = rideIdentity(savedRide) === rideIdentity(normalized) || (
          String(savedRide.year).toLowerCase() === String(normalized.year).toLowerCase() &&
          String(savedRide.make).toLowerCase() === String(normalized.make).toLowerCase() &&
          String(savedRide.model).toLowerCase() === String(normalized.model).toLowerCase()
        );
        if (same) {
          found = true;
          var merged = Object.assign({}, savedRide, normalized, {
            isCurrent: true,
            primaryVehicle: resolvePrimaryVehicle(savedRide)
          });
          if ((!normalized.id || normalized.id.indexOf('|') !== -1) && savedRide.id) {
            merged.id = savedRide.id;
          }
          if (normalized.itemsCount === '' && savedRide.itemsCount !== '') {
            merged.itemsCount = savedRide.itemsCount;
          }
          return merged;
        }
        return Object.assign({}, savedRide, { isCurrent: false });
      });
      var trackingVehicleSave = '';
      if (!found) {
        state.rides.unshift(normalized);
        trackingVehicleSave = [
          normalized.year,
          normalized.make,
          normalized.model
        ].filter(Boolean).join(' ').trim();
      }
      var didWrite = writeLocalRides(state.rides);
      if (didWrite && trackingVehicleSave) {
        try {
          window.sessionStorage.setItem('km_tracking_vehicle_save', trackingVehicleSave);
        } catch (err) {}
      }
      setCurrentLabel(normalized);
      renderSavedRides();
      return didWrite;
    }

    function isSaveSuccess(payload) {
      if (!payload || payload.ok !== true) return false;
      var responsePayload = payload.payload;
      var responseData = responsePayload && typeof responsePayload.data === 'object'
        ? responsePayload.data
        : null;
      var hasDataSuccess = Boolean(
        responseData && Object.prototype.hasOwnProperty.call(responseData, 'success')
      );
      var hasPayloadSuccess = Boolean(
        responsePayload &&
        typeof responsePayload === 'object' &&
        Object.prototype.hasOwnProperty.call(responsePayload, 'success')
      );
      if (!hasDataSuccess && !hasPayloadSuccess) return true;

      var successValue = hasDataSuccess
        ? responseData.success
        : responsePayload.success;
      var normalizedSuccess = String(successValue).trim().toLowerCase();
      return successValue === true || successValue === 1 ||
        normalizedSuccess === 'true' || normalizedSuccess === '1';
    }

    function saveRideToApi(ride) {
      if (!saveUrl) return Promise.resolve(null);
      var payload = {
        year: String(ride.year || ''),
        make: String(ride.make || ''),
        model: String(ride.model || ''),
        email: String(ride.email || '')
      };
      if (isLoggedIn && customerId) payload.userId = customerId;
      return fetchWithTimeout(saveUrl, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }, REQUEST_TIMEOUT_MS).then(function (response) {
        return response.json()
          .catch(function () { return null; })
          .then(function (responsePayload) {
            return {
              ok: response.ok,
              status: response.status,
              payload: responsePayload
            };
          });
      }).catch(function () {
        return { ok: false, status: 0, payload: null };
      });
    }

    function updateCurrentRide(id) {
      if (!isLoggedIn || !id || !updateUrl) return Promise.resolve(null);
      return fetchWithTimeout(updateUrl, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, currentType: 1 })
      }, REQUEST_TIMEOUT_MS).then(function (response) {
        return response.ok ? response.json() : null;
      }).catch(function () {
        return null;
      });
    }

    function extractSavedId(payload) {
      var responsePayload = payload && Object.prototype.hasOwnProperty.call(payload, 'payload')
        ? payload.payload
        : payload;
      var data = responsePayload && responsePayload.data
        ? responsePayload.data
        : responsePayload;
      return data ? String(data.id || data.vehicle_id || data.vehicleId || '') : '';
    }

    function trackSubmit(ride) {
      if (!ride || typeof window.KMTrackVehicleEventAsync !== 'function') return Promise.resolve(false);
      var ymm = typeof window.KMBuildYmmAttributeValue === 'function'
        ? window.KMBuildYmmAttributeValue(ride.year, ride.make, ride.model)
        : [ride.year, ride.make, ride.model].join(' ');
      return window.KMTrackVehicleEventAsync('submit_vehicle_selection', {
        ymm: ymm,
        matched_sku_count: Number(ride.itemsCount) || 0
      }, undefined, { timeout: 800 });
    }

    function getTrackingVehicleValue(ride) {
      return [
        ride && ride.year,
        ride && ride.make,
        ride && ride.model
      ].filter(Boolean).join(' ').trim();
    }

    function trackManualDataEvent(control, options) {
      if (!control || !control.hasAttribute('data-track-manual')) return false;
      var trackingOptions = Object.assign({ allowDisabled: true }, options || {});
      if (typeof window.KMTrackElementEvent === 'function') {
        return window.KMTrackElementEvent(control, trackingOptions);
      }

      var eventName = String(
        trackingOptions.eventName || control.getAttribute('data-track-event') || ''
      ).trim();
      if (!eventName || typeof window.KMTrackGaEvent !== 'function') return false;
      return window.KMTrackGaEvent(eventName, trackingOptions.globalPayload);
    }

    function trackManualDataEventAsync(control, options) {
      if (!control || !control.hasAttribute('data-track-manual')) {
        return Promise.resolve(false);
      }
      var trackingOptions = Object.assign({ allowDisabled: true }, options || {});
      if (typeof window.KMTrackElementEventAsync === 'function') {
        return window.KMTrackElementEventAsync(control, trackingOptions);
      }
      return Promise.resolve(trackManualDataEvent(control, trackingOptions));
    }

    function trackGarageCarSave(control, ride, options) {
      var vehicleSave = getTrackingVehicleValue(ride);
      if (!vehicleSave) return Promise.resolve(false);
      var eventTracking = trackManualDataEventAsync(control, {
        allowDisabled: true,
        eventName: 'garage_car_save',
        globalPayload: { vehicle_save: vehicleSave },
        timeout: 800,
        transport: 'beacon'
      });
      var customerTagTracking = options && options.skipCustomerTag === true
        ? Promise.resolve(false)
        : waitForCustomerTag(addGarageCarSaveCustomerTag(ride));
      return Promise.all([
        Promise.resolve(eventTracking).catch(function () { return false; }),
        customerTagTracking
      ]);
    }

    function saveAndNavigate(ride, noticeMode, showSubscribeButton, trackingControl, trackingOptions) {
      if (state.submitting || !ride.year || !ride.make || !ride.model) return;
      var sequence = ++navigationRequestSequence;
      var isSkipForNow = trackingControl === notNowLink;
      var reloadProductPage = shouldReloadProductAfterRideSave();
      var shouldConfirmProductSubscription = reloadProductPage && trackingControl === subscribeButton;
      var shouldQueueSearchSubscription = !reloadProductPage && noticeMode === 'request';
      var shouldDelayCustomerTags = shouldConfirmProductSubscription || shouldQueueSearchSubscription;
      var customerTagsAfterSubscription = [];
      if (trackingControl === subscribeButton) {
        customerTagsAfterSubscription.push(
          isLoggedIn ? 'ride_updates_submit_login' : 'ride_updates_submit_customer'
        );
      }
      if (!isSkipForNow && !isLoggedIn && !ride.email && isSubscribedCustomer()) {
        var knownSubscriptionEmail = getSubscriptionEmail(ride);
        if (knownSubscriptionEmail) {
          ride = recordEmailBinding(
            'bound',
            knownSubscriptionEmail,
            Object.assign({}, ride)
          );
        }
      }
      var canContinue = function () {
        return !isDestroyed && sequence === navigationRequestSequence;
      };
      var trackSuccessfulGarageSave = function () {
        if (shouldDelayCustomerTags && getTrackingVehicleValue(ride)) {
          var garageCustomerTag = getGarageCarSaveCustomerTag();
          if (
            garageCustomerTag &&
            customerTagsAfterSubscription.indexOf(garageCustomerTag) === -1
          ) {
            customerTagsAfterSubscription.push(garageCustomerTag);
          }
        }
        return trackGarageCarSave(trackingControl, ride, {
          skipCustomerTag: shouldDelayCustomerTags
        });
      };
      var confirmSubscriptionThenAddCustomerTags = function () {
        return confirmRideSubscription(ride.email).then(function (payload) {
          return waitForCustomerTag(
            addCustomerTags(customerTagsAfterSubscription, ride.email)
          ).then(function () {
            return payload;
          });
        });
      };
      state.submitting = true;
      setShopWithoutRideActive(false);
      renderCompleteState();
      var tracking = withTimeout(trackSubmit(ride), TRACKING_TIMEOUT_MS).catch(function () {
        return false;
      });
      var garageCarSaveTracking = Promise.resolve(false);

      if (!isLoggedIn) {
        var savedToGarage = syncLocalRide(ride, '');
        trackManualDataEvent(trackingControl, trackingOptions);
        if (isSkipForNow && savedToGarage) {
          garageCarSaveTracking = trackSuccessfulGarageSave();
        }
        var guestSave = ride.email ? saveRideToApi(ride) : Promise.resolve(null);
        guestSave.then(function (payload) {
          if (!canContinue()) return false;
          var saveSucceeded = isSaveSuccess(payload);
          if (!isSkipForNow && saveSucceeded) {
            garageCarSaveTracking = trackSuccessfulGarageSave();
          }
          var subscriptionConfirmation = Promise.resolve(true);
          if (shouldConfirmProductSubscription) {
            subscriptionConfirmation = saveSucceeded
              ? confirmSubscriptionThenAddCustomerTags()
              : Promise.reject(new Error('Ride save failed'));
          }
          return Promise.all([
            tracking.catch(function () { return false; }),
            garageCarSaveTracking.catch(function () { return false; }),
            subscriptionConfirmation
          ]).then(function () { return true; });
        }).then(function (readyToNavigate) {
          if (!readyToNavigate || !canContinue()) return;
          navigateAfterSave(ride, noticeMode, '', showSubscribeButton, {
            reloadProductPage: reloadProductPage,
            customerTags: shouldQueueSearchSubscription ? customerTagsAfterSubscription : []
          });
        }).catch(function (error) {
          if (!shouldConfirmProductSubscription || !canContinue()) return;
          state.submitting = false;
          showSubscriptionError('Unable to save. Please try again.', false);
          renderCompleteState();
        });
        return;
      }

      saveRideToApi(ride).then(function (payload) {
        if (!canContinue()) return false;
        var saveSucceeded = isSaveSuccess(payload);
        var savedId = extractSavedId(payload);
        var savedToGarage = syncLocalRide(ride, savedId);
        trackManualDataEvent(trackingControl, trackingOptions);
        if (isSkipForNow && savedToGarage) {
          garageCarSaveTracking = trackSuccessfulGarageSave();
        } else if (!isSkipForNow && saveSucceeded) {
          garageCarSaveTracking = trackSuccessfulGarageSave();
        }
        var subscriptionConfirmation = Promise.resolve(true);
        if (shouldConfirmProductSubscription) {
          subscriptionConfirmation = saveSucceeded
            ? confirmSubscriptionThenAddCustomerTags()
            : Promise.reject(new Error('Ride save failed'));
        }
        return Promise.all([
          updateCurrentRide(savedId),
          tracking.catch(function () { return false; }),
          garageCarSaveTracking.catch(function () { return false; }),
          subscriptionConfirmation
        ]).then(function () { return true; });
      }).then(function (readyToNavigate) {
        if (!readyToNavigate || !canContinue()) return;
        navigateAfterSave(ride, noticeMode, '', showSubscribeButton, {
          reloadProductPage: reloadProductPage,
          customerTags: shouldQueueSearchSubscription ? customerTagsAfterSubscription : []
        });
      }).catch(function (error) {
        if (!shouldConfirmProductSubscription || !canContinue()) return;
        state.submitting = false;
        showSubscriptionError('Unable to save. Please try again.', false);
        renderCompleteState();
      });
    }

    function recordEmailBinding(status, email, ride) {
      var bindingStatus = normalizeEmailBinding(status) || 'unbound';
      var normalizedEmail = bindingStatus === 'bound' ? String(email || '').trim().toLowerCase() : '';
      try {
        localStorage.setItem(emailBindingStorageKey, JSON.stringify({
          status: bindingStatus,
          email: normalizedEmail,
          rideId: String(ride.id || ''),
          year: String(ride.year || ''),
          make: String(ride.make || ''),
          model: String(ride.model || ''),
          updatedAt: new Date().toISOString()
        }));
        if (bindingStatus === 'bound') localStorage.setItem(subscribedEmailStorageKey, normalizedEmail);
        else localStorage.removeItem(subscribedEmailStorageKey);
      } catch (error) {}
      ride.emailBinding = bindingStatus;
      if (normalizedEmail) ride.email = normalizedEmail;
      else delete ride.email;
      return ride;
    }

    function recordConfirmedRideSubscription(email) {
      var normalizedEmail = String(email || '').trim().toLowerCase();
      if (!normalizedEmail) return false;

      if (isLoggedIn && normalizedEmail === customerEmail.toLowerCase()) {
        root.setAttribute('data-customer-subscribed', 'true');
        if (window.SHOPIFY_CUSTOMER && window.SHOPIFY_CUSTOMER.loggedIn === true) {
          window.SHOPIFY_CUSTOMER.acceptsMarketing = true;
        }
        document.querySelectorAll('[data-customer-logged-in="true"][data-customer-subscribed]').forEach(function (node) {
          var nodeEmail = String(node.getAttribute('data-customer-email') || '').trim().toLowerCase();
          if (!nodeEmail || nodeEmail === normalizedEmail) {
            node.setAttribute('data-customer-subscribed', 'true');
          }
        });
      }

      try {
        localStorage.setItem(subscribedEmailStorageKey, normalizedEmail);
        if (isLoggedIn) {
          localStorage.removeItem(confirmedSubscribedEmailStorageKey);
        } else {
          localStorage.setItem(confirmedSubscribedEmailStorageKey, normalizedEmail);
        }
      } catch (error) {}
      return true;
    }

    function confirmRideSubscription(email) {
      var normalizedEmail = String(email || '').trim();
      if (!subscriptionUrl || !validEmail(normalizedEmail)) {
        return Promise.reject(new Error('Missing subscription request data'));
      }

      return fetchWithTimeout(subscriptionUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: normalizedEmail,
          shop: 'kemimoto_us',
          source: 'save-vehicle',
          showSubscribeButton: true
        })
      }, REQUEST_TIMEOUT_MS).then(function (response) {
        return response.json().catch(function () { return null; }).then(function (payload) {
          if (!response.ok || !payload || Number(payload.code) !== 200) {
            throw new Error(String(payload && payload.msg || 'Subscription request failed'));
          }
          recordConfirmedRideSubscription(normalizedEmail);
          return payload;
        });
      });
    }

    function validEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
    }

    function resolveCount(payload) {
      if (typeof payload === 'number') return payload;
      if (typeof payload === 'string' && payload.trim() !== '' && !isNaN(Number(payload))) return Number(payload);
      if (!payload || typeof payload !== 'object') return 0;
      var keys = ['itemsCount', 'items', 'items_count', 'itemCount', 'count'];
      for (var i = 0; i < keys.length; i += 1) {
        var value = payload[keys[i]];
        if (value !== undefined && value !== null && value !== '' && !isNaN(Number(value))) return Number(value);
      }
      if (payload.result !== undefined && payload.result !== payload) return resolveCount(payload.result);
      if (payload.data !== undefined && payload.data !== payload) return resolveCount(payload.data);
      return 0;
    }

    function getKnownEmail() {
      if (customerEmail) return customerEmail;
      try {
        return String(localStorage.getItem(subscribedEmailStorageKey) || '').trim();
      } catch (error) {
        return '';
      }
    }

    function fetchCount(ride) {
      return fetchJson(countUrl, {
        year: ride.year,
        make: ride.make,
        model: ride.model,
        email: ride.email || getKnownEmail()
      }, undefined, REQUEST_TIMEOUT_MS).catch(function () {
        return null;
      });
    }

    function trackFallbackResults(ride, payload) {
      var source = unwrapPayload(payload);
      var exactType = source && source.type !== undefined ? source.type : '';
      if (exactType === '' && payload && payload.type !== undefined) exactType = payload.type;
      var ymm = typeof window.KMBuildYmmAttributeValue === 'function'
        ? window.KMBuildYmmAttributeValue(ride.year, ride.make, ride.model)
        : [ride.year, ride.make, ride.model].filter(Boolean).join(' ');
      if (!ymm) return false;
      var eventPayload = {
        ymm: ymm,
        exact_type: String(exactType === undefined || exactType === null ? '' : exactType)
      };
      if (typeof window.KMTrackVehicleEvent === 'function') {
        return window.KMTrackVehicleEvent('view_fallback_results', eventPayload);
      }
      if (typeof window.KMGetVehicleEntrySource === 'function') {
        var entrySource = window.KMGetVehicleEntrySource();
        if (entrySource) eventPayload.entry_source = entrySource;
      }
      if (typeof window.KMTrackGaEvent === 'function') {
        return window.KMTrackGaEvent('view_fallback_results', eventPayload);
      }
      return false;
    }

    function blurActiveSheetInput() {
      var activeElement = document.activeElement;
      if (!activeElement || !sheet.contains(activeElement)) return;
      if (typeof activeElement.matches !== 'function') return;
      if (!activeElement.matches('input, textarea, [contenteditable="true"]')) return;
      if (typeof activeElement.blur === 'function') activeElement.blur();
    }

    function enterComplete() {
      state.stage = 'complete';
      blurActiveSheetInput();
      state.manualKind = '';
      state.filter = '';
      clearSubscriptionError();
      if (state.selected.model && !state.options.model.some(function (model) {
        return String(model).toLowerCase() === String(state.selected.model).toLowerCase();
      })) {
        state.options.model.unshift(state.selected.model);
      }
      state.count = 0;
      state.countLoading = true;
      state.submitting = false;
      var sequence = ++countRequestSequence;
      var ride = buildRideFromSelection();
      var productRequestKey = isProductFitCartEntry() ? buildProductFitmentKey(ride) : '';
      if (productRequestKey) {
        state.completionMode = 'product-pending';
        state.productFitmentStatus = 'pending';
        state.productFitmentKey = productRequestKey;
      } else {
        resetProductFitmentState();
        state.completionMode = isSubscribedCustomer() ? 'subscribed' : 'subscription';
        prefillSubscriptionEmail();
      }
      render();
      if (typeof window.KMTrackVehicleAttribute === 'function') {
        var ymm = typeof window.KMBuildYmmAttributeValue === 'function'
          ? window.KMBuildYmmAttributeValue(ride.year, ride.make, ride.model)
          : [ride.year, ride.make, ride.model].join(' ');
        window.KMTrackVehicleAttribute('ymm', ymm);
      }
      Promise.all([
        fetchCount(ride),
        productRequestKey ? fetchProductFitment(ride) : Promise.resolve('unknown')
      ]).then(function (results) {
        if (sequence !== countRequestSequence || state.stage !== 'complete') return;
        var payload = results[0];
        var productStatus = results[1];
        state.count = resolveCount(payload);
        state.countLoading = false;
        if (payload !== null) trackFallbackResults(ride, payload);

        if (productRequestKey && state.productFitmentKey === productRequestKey) {
          state.productFitmentStatus = productStatus;
          if (productStatus === 'fit') {
            if (hasSavedRide()) {
              state.completionMode = 'product-fit-saved';
            } else {
              state.completionMode = 'subscription';
              prefillSubscriptionEmail(true);
            }
          } else if (productStatus === 'unfit') {
            state.completionMode = 'product-unfit';
          } else {
            state.completionMode = isSubscribedCustomer() ? 'subscribed' : 'subscription';
            if (state.completionMode === 'subscription') prefillSubscriptionEmail();
          }
        }
        render();
      });
    }

    function cancelPendingTransition() {
      window.clearTimeout(transitionTimer);
      transitionTimer = 0;
      if (optionsWrap) optionsWrap.removeAttribute('aria-busy');
    }

    function resetDraft() {
      cancelPendingTransition();
      countRequestSequence += 1;
      makeRequestSequence += 1;
      modelRequestSequence += 1;
      navigationRequestSequence += 1;
      state.selected = { year: '', make: '', model: '', isCustom: false };
      state.options.make = [];
      state.options.model = [];
      state.optionsLoading = false;
      state.manualKind = '';
      state.filter = '';
      state.count = 0;
      state.countLoading = false;
      state.submitting = false;
      state.completionMode = '';
      resetProductFitmentState();
      if (filterInput) filterInput.value = '';
      if (manualInput) manualInput.value = '';
      if (subscriptionEmail) subscriptionEmail.value = getDefaultSubscriptionEmail();
      clearSubscriptionError();
    }

    function showStage(stage) {
      cancelPendingTransition();
      state.stage = stage;
      state.filter = '';
      state.manualKind = '';
      state.optionsLoading = false;
      if (filterInput) filterInput.value = '';
      if (manualInput) manualInput.value = '';
      if (stage !== 'complete') {
        countRequestSequence += 1;
        state.count = 0;
        state.countLoading = false;
        state.submitting = false;
        state.completionMode = '';
        resetProductFitmentState();
        clearSubscriptionError();
      }
      render();
      if (stage === 'year') ensureYears();
    }

    function openAdd() {
      resetDraft();
      showStage('year');
    }

    window.KMMobileRideOpenAdd = function (element) {
      if (!element || typeof element.closest !== 'function') return;
      var elementSheet = element.closest('[data-mobile-ride-sheet]');
      var entry = element.closest('[data-mobile-ride-entry]') || (elementSheet && elementSheet.__kmMobileRideOwner);
      if (entry && entry.__kmMobileRideController) entry.__kmMobileRideController.openAdd();
    };

    function refreshRidesFromStorage(preserveExisting) {
      var snapshot = readLocalRidesSnapshot();
      if (snapshot.ok) {
        state.rides = preserveExisting
          ? mergeRides(state.rides, snapshot.rides)
          : snapshot.rides;
      }
      if (isShopWithoutRideActive()) {
        state.rides = state.rides.map(function (ride) {
          return Object.assign({}, ride, { isCurrent: false });
        });
      }
      setCurrentLabel(currentRide());
      if (ridePromptController) ridePromptController.refreshRideState();
    }

    function trackGarageEntryShow() {
      if (sheet.getAttribute('data-garage-entry-show-tracked') === 'true') return;
      sheet.setAttribute('data-garage-entry-show-tracked', 'true');

      if (typeof window.KMTrackElementViewEvent === 'function') {
        window.KMTrackElementViewEvent(sheet, { repeat: true });
        return;
      }

      sheet.removeAttribute('data-track-view-sent');
      sheet.setAttribute('data-track-view-pending', 'true');
      if (typeof window.CustomEvent === 'function') {
        sheet.dispatchEvent(new CustomEvent('km:track-view', { bubbles: true }));
      }
    }

    function openSheet() {
      if (isDestroyed) return;
      beginGarageTagFlow();
      if (typeof window.KMMarkRidePickerOpenedForSession === 'function') {
        window.KMMarkRidePickerOpenedForSession();
      }
      mountSheet();
      Array.prototype.forEach.call(document.querySelectorAll('[data-mobile-ride-sheet].is-open'), function (otherSheet) {
        if (otherSheet === sheet) return;
        var owner = otherSheet.__kmMobileRideOwner;
        if (owner && owner.__kmMobileRideController && owner.__kmMobileRideController.closeSheet) {
          owner.__kmMobileRideController.closeSheet(true);
          return;
        }
        otherSheet.classList.remove('is-open');
        otherSheet.setAttribute('aria-hidden', 'true');
        otherSheet.removeAttribute('data-garage-entry-show-tracked');
      });
      hideThirdPartyPopups();
      if (!(isLoggedIn && garageRequestSucceeded)) refreshRidesFromStorage(false);
      else setCurrentLabel(currentRide());
      notifyRideStorageChange();
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mobile-ride-sheet-open');
      trackGarageEntryShow();
      window.clearTimeout(popupHideTimer);
      popupHideTimer = window.setTimeout(function () {
        popupHideTimer = 0;
        if (!isDestroyed) hideThirdPartyPopups();
      }, 120);
      if (state.garageReady) {
        resetDraft();
        state.stage = state.rides.length ? 'saved' : 'year';
        render();
        if (state.stage === 'year') ensureYears();
      } else {
        render();
      }
    }

    function setShopWithoutRideTooltipVisible(visible) {
      if (!shopWithoutRideTooltip || !shopWithoutRideTooltipTrigger) return;
      var show = Boolean(visible);
      shopWithoutRideTooltip.classList.toggle('is-open', show);
      shopWithoutRideTooltipTrigger.setAttribute('aria-expanded', show ? 'true' : 'false');
      if (shopWithoutRideTooltipPanel) {
        shopWithoutRideTooltipPanel.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
    }

    function handleShopWithoutRideTooltip(event) {
      event.preventDefault();
      event.stopPropagation();
      setShopWithoutRideTooltipVisible(!shopWithoutRideTooltip.classList.contains('is-open'));
    }

    function handleShopWithoutRideTooltipOutside(event) {
      if (!shopWithoutRideTooltip || !shopWithoutRideTooltip.classList.contains('is-open')) return;
      var target = event.target;
      if (target && typeof target.closest === 'function' && target.closest('[data-mobile-shop-without-tooltip]')) return;
      setShopWithoutRideTooltipVisible(false);
    }

    function closeSheet(preserveEntrySource) {
      cancelPendingTransition();
      window.clearTimeout(popupHideTimer);
      popupHideTimer = 0;
      makeRequestSequence += 1;
      modelRequestSequence += 1;
      countRequestSequence += 1;
      primaryHydrationSequence += 1;
      state.primaryHydrating = false;
      setShopWithoutRideTooltipVisible(false);
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      sheet.removeAttribute('data-garage-entry-show-tracked');
      setFitCartEntry(false);
      var hasOpenSheet = Boolean(document.querySelector('[data-mobile-ride-sheet].is-open'));
      document.body.classList.toggle('mobile-ride-sheet-open', hasOpenSheet);
      if (preserveEntrySource !== true && typeof window.KMClearVehicleEntrySource === 'function') {
        window.KMClearVehicleEntrySource();
      }
      if (preserveEntrySource !== true) {
        window.setTimeout(function () {
          if (document.querySelector('[data-header-modal].is-open, [data-mobile-ride-sheet].is-open')) return;
          if (typeof window.KMClearDataTrackEntryLocation === 'function') {
            window.KMClearDataTrackEntryLocation();
          } else {
            window.__KM_DATA_TRACK_ENTRY_LOCATION__ = '';
          }
        }, 0);
      }
      if (preserveEntrySource !== true) endGarageTagFlow();
      if (hasOpenSheet) hideThirdPartyPopups();
      else restoreThirdPartyPopups();
    }

    function currentOptionStage() {
      return state.stage === 'complete' ? 'model' : state.stage;
    }

    function optionValues() {
      var values = state.options[currentOptionStage()] || [];
      var query = state.filter.toLowerCase();
      if (!query) return values;
      return values.filter(function (value) {
        return String(value).toLowerCase().indexOf(query) !== -1;
      });
    }

    function selectOption(button, callback, delayTransition) {
      cancelPendingTransition();
      if (button) {
        Array.prototype.forEach.call(optionsWrap.querySelectorAll('.mobile-ride-sheet__option.is-selected'), function (option) {
          option.classList.remove('is-selected');
          option.setAttribute('aria-selected', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-selected', 'true');
      }
      if (!delayTransition) {
        callback();
        return;
      }
      optionsWrap.setAttribute('aria-busy', 'true');
      transitionTimer = window.setTimeout(function () {
        transitionTimer = 0;
        optionsWrap.removeAttribute('aria-busy');
        callback();
      }, 90);
    }

    function chooseYear(value, button) {
      selectOption(button, function () {
        var changed = String(state.selected.year) !== String(value);
        var shouldFetch = changed || !state.options.make.length;
        var sequence = shouldFetch ? ++makeRequestSequence : makeRequestSequence;
        state.selected.year = value;
        if (changed) {
          modelRequestSequence += 1;
          state.selected.make = '';
          state.selected.model = '';
          state.selected.isCustom = false;
          state.options.make = [];
          state.options.model = [];
        }
        state.stage = 'make';
        state.filter = '';
        state.optionsLoading = shouldFetch;
        if (filterInput) filterInput.value = '';
        render();
        if (!shouldFetch) return;
        fetchMakes(value).then(function (makes) {
          if (sequence !== makeRequestSequence || state.selected.year !== value || state.stage !== 'make') return;
          state.options.make = makes;
          state.optionsLoading = false;
          render();
        });
      });
    }

    function chooseMake(value, button) {
      selectOption(button, function () {
        var changed = String(state.selected.make) !== String(value);
        state.filter = '';
        if (filterInput) filterInput.value = '';
        if (isOther(value)) {
          modelRequestSequence += 1;
          state.selected.make = '';
          state.selected.model = '';
          state.selected.isCustom = true;
          state.options.model = [];
          state.manualKind = 'make';
          render();
          if (manualInput) manualInput.focus();
          return;
        }
        var shouldFetch = changed || !state.options.model.length;
        var sequence = shouldFetch ? ++modelRequestSequence : modelRequestSequence;
        state.selected.make = value;
        if (changed) {
          state.selected.model = '';
          state.selected.isCustom = false;
          state.options.model = [];
        }
        state.stage = 'model';
        state.manualKind = '';
        state.optionsLoading = shouldFetch;
        render();
        if (!shouldFetch) return;
        fetchModels(state.selected.year, value).then(function (models) {
          if (sequence !== modelRequestSequence || state.selected.make !== value || state.stage !== 'model') return;
          state.options.model = models;
          state.optionsLoading = false;
          render();
        });
      });
    }

    function chooseModel(value, button) {
      var replacingCompleteModel = state.stage === 'complete';
      if (replacingCompleteModel) {
        countRequestSequence += 1;
        state.count = 0;
        state.countLoading = true;
        state.submitting = false;
        renderCompleteState();
      }
      selectOption(button, function () {
        state.filter = '';
        if (filterInput) filterInput.value = '';
        if (isOther(value)) {
          state.selected.model = '';
          state.selected.isCustom = true;
          state.stage = 'model';
          state.completionMode = '';
          resetProductFitmentState();
          state.count = 0;
          state.countLoading = false;
          state.manualKind = 'model';
          render();
          if (manualInput) manualInput.focus();
          return;
        }
        state.selected.model = value;
        enterComplete();
      });
    }

    function handleManualContinue() {
      var value = String(manualInput ? manualInput.value : '').trim();
      if (!value) {
        if (manualError) manualError.hidden = false;
        return;
      }
      if (manualError) manualError.hidden = true;
      if (state.manualKind === 'make') {
        state.selected.make = value;
        state.selected.model = '';
        state.selected.isCustom = true;
        state.stage = 'model';
        state.manualKind = 'model';
        if (manualInput) manualInput.value = '';
        render();
        if (manualInput) manualInput.focus();
        return;
      }
      if (state.manualKind === 'model') {
        state.selected.model = value;
        state.selected.isCustom = true;
        if (manualInput) manualInput.value = '';
        enterComplete();
      }
    }

    function renderOptions() {
      if (!optionsWrap) return;
      var optionStage = currentOptionStage();
      optionsWrap.innerHTML = '';
      optionsWrap.classList.toggle('is-year-grid', optionStage === 'year');
      if (state.optionsLoading) {
        var loading = document.createElement('div');
        loading.className = 'mobile-ride-sheet__empty';
        loading.innerHTML = '<span class="mobile-ride-sheet__spinner" aria-hidden="true"></span>';
        optionsWrap.appendChild(loading);
        return;
      }
      var values = optionValues();
      if (!values.length) {
        var empty = document.createElement('p');
        empty.className = 'mobile-ride-sheet__empty';
        empty.textContent = state.filter ? 'No matching options.' : 'No options available.';
        optionsWrap.appendChild(empty);
        return;
      }
      values.forEach(function (value) {
        var selected = state.selected[optionStage] === value;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'mobile-ride-sheet__option' + (selected ? ' is-selected' : '');
        button.setAttribute('role', 'option');
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
        var label = document.createElement('span');
        label.textContent = value;
        button.appendChild(label);
        if (optionStage === 'model' || optionStage === 'make') {
          if (selected) {
            var check = document.createElement('span');
            check.className = 'mobile-ride-sheet__option-check';
            check.setAttribute('aria-hidden', 'true');
            check.textContent = '\u2713';
            button.appendChild(check);
          }
        }
        button.addEventListener('click', function () {
          if (optionStage === 'year') chooseYear(value, button);
          else if (optionStage === 'make') chooseMake(value, button);
          else if (optionStage === 'model') chooseModel(value, button);
        });
        optionsWrap.appendChild(button);
      });
    }

    function renderSteps() {
      var order = ['year', 'make', 'model'];
      var complete = state.stage === 'complete';
      var directView = complete && isDirectViewCompletion();
      stepButtons.forEach(function (button) {
        var key = button.getAttribute('data-mobile-step');
        var index = order.indexOf(key);
        var value = state.selected[key];
        var label = button.querySelector('[data-mobile-step-label]');
        var active = key === state.stage || (directView && key === 'model');
        var stepComplete = Boolean(value && !active);
        var fallback = directView && key === 'model'
          ? '3.Model'
          : String(index + 1) + '. ' + key.charAt(0).toUpperCase() + key.slice(1);
        if (label) label.textContent = stepComplete ? value : fallback;
        button.classList.toggle('is-active', active);
        button.classList.toggle('is-complete', stepComplete);
        button.disabled = !stepComplete && !(directView && key === 'model');
        button.setAttribute('aria-current', active ? 'step' : 'false');
      });
    }

    function renderCurrentSummary() {
      if (!currentValue) return;
      var values = [];
      if (state.selected.year) values.push(state.selected.year);
      if (state.selected.make) values.push(state.selected.make);
      currentValue.textContent = values.join(' / ');
    }

    function renderManual() {
      var active = Boolean(state.manualKind);
      if (manualWrap) manualWrap.hidden = !active;
      if (incompleteAction && state.stage !== 'complete') incompleteAction.hidden = active;
      if (filterInput && filterInput.closest('.mobile-ride-sheet__filter')) {
        filterInput.closest('.mobile-ride-sheet__filter').hidden = active;
      }
      if (optionsWrap) optionsWrap.hidden = active;
      if (!active) return;
      var name = state.manualKind === 'make' ? 'make' : 'model';
      if (manualLabel) manualLabel.textContent = 'Enter ' + name;
      if (manualInput) manualInput.placeholder = 'Enter ' + name;
      if (manualError) manualError.hidden = true;
    }

    function renderCompleteState() {
      if (isDestroyed) return;
      var ride = buildRideFromSelection();
      var count = Number(state.count) || 0;
      var directView = isDirectViewCompletion();
      var productPending = state.completionMode === 'product-pending';
      var productFitSaved = state.completionMode === 'product-fit-saved';
      var productUnfit = state.completionMode === 'product-unfit';
      var productFitWithoutSavedRide = Boolean(
        isProductFitCartEntry() &&
        state.productFitmentStatus === 'fit' &&
        state.completionMode === 'subscription' &&
        !hasSavedRide()
      );
      if (fitmentLabel) fitmentLabel.textContent = [ride.year, ride.make, ride.model].join(' / ');
      if (fitmentPrefix) fitmentPrefix.textContent = productUnfit ? 'Not compatible with:' : 'Fitment confirmed:';
      if (fitmentSummary) fitmentSummary.classList.toggle('is-unfit', productUnfit);
      if (confirmedRideLabel) confirmedRideLabel.textContent = [ride.year, ride.make, ride.model].join(' ');
      if (subscribedComplete) subscribedComplete.hidden = !directView;
      if (subscriptionComplete) subscriptionComplete.hidden = directView;
      if (viewItemsLabel) {
        viewItemsLabel.textContent = productPending || productFitSaved || productUnfit
          ? 'View'
          : (state.countLoading ? 'View Items' : 'View ' + count + ' Items');
      }
      if (countSpinner) countSpinner.hidden = !state.countLoading;
      if (viewItemsButton) viewItemsButton.disabled = state.countLoading || state.submitting;
      if (subscribeLabel) {
        subscribeLabel.textContent = productFitWithoutSavedRide
          ? 'Save & View'
          : (state.countLoading ? 'Save & View Items' : 'Save & View ' + count + ' Items');
      }
      if (subscribeSpinner) subscribeSpinner.hidden = !state.countLoading && !state.submitting;
      if (subscribeButton) subscribeButton.disabled = state.countLoading || state.submitting;
      if (notNowLink) {
        notNowLink.href = buildSearchUrl(ride);
        notNowLink.classList.toggle('is-disabled', state.countLoading || state.submitting);
        notNowLink.setAttribute('aria-disabled', state.countLoading || state.submitting ? 'true' : 'false');
      }
    }

    function primaryRideLabel(ride) {
      return [ride && ride.year, ride && ride.make, ride && ride.model].filter(Boolean).join(' ');
    }

    function showPrimaryError(message, invalidEmail) {
      if (primaryError) {
        primaryError.textContent = String(message || 'Unable to save your primary ride. Please try again.');
        primaryError.hidden = false;
      }
      if (primaryEmail) primaryEmail.setAttribute('aria-invalid', invalidEmail ? 'true' : 'false');
    }

    function clearPrimaryError() {
      if (primaryError) primaryError.hidden = true;
      if (primaryEmail) primaryEmail.setAttribute('aria-invalid', 'false');
    }

    function openPrimaryRide() {
      if (!state.rides.length) return;
      primaryHydrationSequence += 1;
      state.primaryHydrating = false;
      var currentPrimary = getPrimaryRide();
      var knownEmail = getKnownPrimarySubscriptionEmail();
      var shouldRestoreResult = Boolean(currentPrimary && knownEmail);
      state.primarySelectedId = shouldRestoreResult ? String(currentPrimary.id || '') : '';
      state.primarySubscriptionConfirmed = false;
      state.primaryDiscountCode = '';
      state.primaryResultHydrated = false;
      if (primaryEmail) primaryEmail.value = knownEmail || (isLoggedIn ? customerEmail : '');
      clearPrimaryError();
      state.stage = 'primary';
      render();
      if (shouldRestoreResult) loadExistingPrimarySubscription(knownEmail);
    }

    function renderPrimaryRide() {
      if (!primaryStage || !primaryList) return;
      var currentPrimary = getPrimaryRide();
      var currentPrimaryId = String(currentPrimary && currentPrimary.id || '');
      var selectedId = String(state.primarySelectedId || '');
      var selectedRide = state.rides.find(function (ride) {
        return String(ride.id || '') === selectedId;
      }) || null;
      var subscriptionRequired = Boolean(selectedRide && needsPrimarySubscription());
      var changed = Boolean(selectedRide && selectedId !== currentPrimaryId);
      var hasDiscountCode = Boolean(state.primarySubscriptionConfirmed && state.primaryDiscountCode);

      primaryList.innerHTML = '';
      state.rides.forEach(function (ride) {
        var rideId = String(ride.id || '');
        var selected = rideId === selectedId || (!selectedId && rideId === currentPrimaryId);
        var primary = resolvePrimaryVehicle(ride) === 1;
        var option = document.createElement('button');
        option.type = 'button';
        option.className = 'mobile-ride-sheet__primary-option' +
          (primary ? ' is-primary' : '') +
          (selected ? ' is-selected' : '');
        option.setAttribute('data-mobile-primary-option', rideId);
        option.setAttribute('data-track-event', 'primary_ride_select');
        option.setAttribute('data-track-payload', JSON.stringify({
          ride_name: primaryRideLabel(ride)
        }));
        option.setAttribute('data-primary', primary ? 'true' : 'false');
        option.setAttribute('aria-pressed', selected ? 'true' : 'false');
        option.innerHTML = '<span class="mobile-ride-sheet__primary-option-icon" aria-hidden="true">' +
          '<svg class="mobile-ride-sheet__primary-option-icon-empty" xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none" focusable="false">' +
            '<path d="M12.7905 5.48584L19.0218 6.90999L14.8177 11.7244L15.389 18.09L9.51091 15.5802L3.63281 18.09L4.2041 11.7244L0 6.90999L6.23128 5.48584L9.51091 0L12.7905 5.48584ZM7.08333 6.65853L2.47152 7.7124L5.58268 11.276L5.15951 15.988L9.51091 14.13L13.8615 15.988L13.4391 11.276L16.5495 7.7124L11.9385 6.65853L9.51091 2.59766L7.08333 6.65853Z" fill="currentColor"></path>' +
          '</svg>' +
          '<svg class="mobile-ride-sheet__primary-option-icon-selected" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" focusable="false">' +
            '<path d="M13.2798 6.31787L19.5111 7.74203L15.307 12.5565L15.8783 18.922L10.0002 16.4123L4.12207 18.922L4.69336 12.5565L0.489258 7.74203L6.72054 6.31787L10.0002 0.832031L13.2798 6.31787Z" fill="currentColor"></path>' +
          '</svg>' +
          '</span>' +
          '<span class="mobile-ride-sheet__primary-option-name"></span>';
        option.querySelector('.mobile-ride-sheet__primary-option-name').textContent = primaryRideLabel(ride);
        option.addEventListener('click', function () {
          if (state.primarySubmitting || state.primaryHydrating) return;
          state.primarySelectedId = rideId;
          if (!state.primaryResultHydrated) {
            state.primarySubscriptionConfirmed = false;
            state.primaryDiscountCode = '';
          }
          clearPrimaryError();
          render();
        });
        primaryList.appendChild(option);
      });

      if (primarySubscriptionForm) {
        primarySubscriptionForm.hidden = !subscriptionRequired || state.primarySubscriptionConfirmed;
      }
      sheet.setAttribute(
        'data-mobile-primary-subscription-visible',
        subscriptionRequired && !state.primarySubscriptionConfirmed ? 'true' : 'false'
      );
      sheet.setAttribute(
        'data-mobile-primary-success-visible',
        hasDiscountCode ? 'true' : 'false'
      );
      if (primarySuccess) primarySuccess.hidden = !hasDiscountCode;
      if (primaryDiscount) primaryDiscount.hidden = !hasDiscountCode;
      if (primaryDiscountCode) primaryDiscountCode.textContent = hasDiscountCode ? state.primaryDiscountCode : '';
      if (primaryDiscountCopy) primaryDiscountCopy.textContent = 'Copy';
      if (primaryOffer) primaryOffer.hidden = !subscriptionRequired || state.primarySubscriptionConfirmed;
      var primaryBusy = state.primarySubmitting || state.primaryHydrating;
      if (primarySave) {
        primarySave.hidden = !selectedRide;
        primarySave.disabled = primaryBusy || (!subscriptionRequired && !changed);
      }
      if (primarySaveLabel) primarySaveLabel.textContent = 'Save as primary ride';
      if (primarySpinner) primarySpinner.hidden = !primaryBusy;
      if (primaryEmail) primaryEmail.disabled = primaryBusy;
    }

    function applyPrimarySubscriptionResult(responsePayload, normalizedEmail) {
      try { localStorage.setItem(primaryEmailStorageKey, normalizedEmail); } catch (error) {}
      if (isLoggedIn) root.setAttribute('data-customer-subscribed', 'true');
      state.primarySubscriptionConfirmed = true;
      state.primaryDiscountCode = String(responsePayload.data && responsePayload.data.discountCode || '').trim();
    }

    function confirmPrimarySubscription(email, options) {
      var normalizedEmail = String(email || '').trim();
      if (!validEmail(normalizedEmail)) return Promise.reject(new Error('invalid-email'));
      var payload = {
        email: normalizedEmail,
        shop: 'kemimoto_us',
        showSubscribeButton: false,
        source: 'save-vehicle'
      };
      return withTimeout(waitForGarageApi().then(function (api) {
        return api.post(normalizeApiEndpoint(subscriptionUrl), payload, false, {}, { credentials: 'include' });
      }), REQUEST_TIMEOUT_MS).then(function (responsePayload) {
        if (!responsePayload || Number(responsePayload.code) !== 200) {
          throw new Error(String(responsePayload && responsePayload.msg || 'Subscription request failed'));
        }
        if (!options || options.deferState !== true) {
          applyPrimarySubscriptionResult(responsePayload, normalizedEmail);
        }
        return responsePayload;
      });
    }

    function loadExistingPrimarySubscription(email) {
      var requestSequence = ++primaryHydrationSequence;
      state.primaryHydrating = true;
      clearPrimaryError();
      render();
      confirmPrimarySubscription(email, { deferState: true }).then(function (responsePayload) {
        if (requestSequence !== primaryHydrationSequence || state.stage !== 'primary') return;
        applyPrimarySubscriptionResult(responsePayload, String(email || '').trim());
        state.primaryResultHydrated = true;
      }).catch(function () {
        if (requestSequence !== primaryHydrationSequence || state.stage !== 'primary') return;
        showPrimaryError('Unable to load your subscription offer. Please try again.', false);
      }).finally(function () {
        if (requestSequence !== primaryHydrationSequence) return;
        state.primaryHydrating = false;
        render();
      });
    }

    function switchPrimaryRide(rideId) {
      if (!isLoggedIn) {
        state.rides = state.rides.map(function (ride) {
          return Object.assign({}, ride, { primaryVehicle: String(ride.id || '') === rideId ? 1 : 0 });
        });
        if (!writeLocalRides(state.rides)) return Promise.reject(new Error('Unable to save primary ride locally'));
        return Promise.resolve(state.rides);
      }

      var numericRideId = Number(rideId);
      var numericUserId = Number(customerId);
      if (!Number.isInteger(numericRideId) || numericRideId < 1 || !Number.isInteger(numericUserId) || numericUserId < 0) {
        return Promise.reject(new Error('Invalid primary ride request'));
      }
      return withTimeout(waitForGarageApi().then(function (api) {
        return api.post(normalizeApiEndpoint(primarySwitchUrl), {
          id: numericRideId,
          shop: 'kemimoto_us',
          userId: numericUserId
        }, false, {}, { credentials: 'include' });
      }), REQUEST_TIMEOUT_MS).then(function (payload) {
        if (!payload || Number(payload.code) !== 200) {
          throw new Error(String(payload && payload.msg || 'Unable to change primary ride'));
        }
        return refreshPrimaryRidesFromApi();
      }).then(function (remoteRides) {
        state.rides = replaceRidesWithRemote(remoteRides, readLocalRides());
        writeLocalRides(state.rides);
        return state.rides;
      });
    }

    function savePrimaryRide(event) {
      if (event) event.preventDefault();
      if (state.primarySubmitting || state.primaryHydrating || !state.primarySelectedId) return;
      var selectedId = String(state.primarySelectedId);
      var currentPrimary = getPrimaryRide();
      var changed = selectedId !== String(currentPrimary && currentPrimary.id || '');
      var subscriptionRequired = needsPrimarySubscription();
      if (!changed && !subscriptionRequired) return;

      var email = String(primaryEmail && primaryEmail.value || '').trim();
      if (subscriptionRequired && !validEmail(email)) {
        showPrimaryError('Please enter a valid email address.', true);
        if (primaryEmail) primaryEmail.focus();
        return;
      }

      state.primarySubmitting = true;
      clearPrimaryError();
      render();
      var subscription = subscriptionRequired ? confirmPrimarySubscription(email) : Promise.resolve(null);
      subscription.then(function () {
        return changed ? switchPrimaryRide(selectedId) : state.rides;
      }).then(function () {
        render();
      }).catch(function (error) {
        if (String(error && error.message || '') === 'invalid-email') {
          showPrimaryError('Please enter a valid email address.', true);
        } else {
          showPrimaryError('Unable to save your primary ride. Please try again.', false);
        }
      }).finally(function () {
        state.primarySubmitting = false;
        render();
      });
    }

    function render() {
      if (isDestroyed) return;
      var loading = !state.garageReady;
      var complete = state.stage === 'complete';
      var primary = state.stage === 'primary';
      var directView = complete && isDirectViewCompletion();
      var productPending = complete && state.completionMode === 'product-pending';
      var trackViewItems = complete && (
        state.completionMode === 'subscribed' ||
        state.completionMode === 'product-fit-saved'
      );
      syncEditableSubscriptionEmailPrompt(complete && !directView);
      if (viewItemsButton) {
        if (trackViewItems) viewItemsButton.setAttribute('data-track-event', 'garage_view_items');
        else viewItemsButton.removeAttribute('data-track-event');
      }
      var renderedStage = loading ? 'loading' : state.stage;
      var renderedCompletion = complete ? state.completionMode : '';
      if (!primary) {
        sheet.removeAttribute('data-mobile-primary-subscription-visible');
        sheet.removeAttribute('data-mobile-primary-success-visible');
      }
      root.setAttribute('data-mobile-current-stage', renderedStage);
      root.setAttribute('data-mobile-completion-state', renderedCompletion);
      sheet.setAttribute('data-mobile-current-stage', renderedStage);
      sheet.setAttribute('data-mobile-completion-state', renderedCompletion);
      if (garageLoading) garageLoading.hidden = !loading;
      if (footer) footer.hidden = loading || primary;
      if (savedStage) savedStage.hidden = loading || state.stage !== 'saved';
      if (primaryStage) primaryStage.hidden = loading || !primary;
      if (pickerStage) pickerStage.hidden = loading || state.stage === 'saved' || primary;
      if (stageTitle) {
        if (loading || state.stage === 'saved') stageTitle.textContent = 'My Garage';
        else if (primary) stageTitle.textContent = getPrimaryRide()
          ? 'Select your primary ride'
          : 'Change primary ride';
        else stageTitle.textContent = getPickerTitle();
      }
      if (shopWithoutRideWrap) shopWithoutRideWrap.hidden = primary;
      if (primaryChange) {
        primaryChange.hidden = loading || state.stage !== 'saved' || !state.rides.length || !getPrimaryRide();
      }
      if (signInLink) signInLink.hidden = primary;
      if (backButton) backButton.hidden = loading || state.stage === 'saved' || !state.rides.length;
      if (addButton) addButton.hidden = loading || state.stage !== 'saved';
      if (incompleteAction) incompleteAction.hidden = loading || state.stage === 'saved' || primary || complete;
      if (subscribedComplete) subscribedComplete.hidden = !directView;
      if (subscribeAction) subscribeAction.hidden = !complete || directView;
      if (notNowLink) notNowLink.hidden = !complete || directView;
      if (loading) return;
      if (state.stage === 'saved') {
        renderSavedRides();
        return;
      }
      if (primary) {
        renderPrimaryRide();
        return;
      }
      renderSteps();
      renderCurrentSummary();
      if (currentSummary) currentSummary.hidden = complete;
      if (fitmentSummary) fitmentSummary.hidden = !directView || productPending;
      if (choiceStage) choiceStage.hidden = complete && !directView;
      if (completeWrap) completeWrap.hidden = !complete || directView;
      if (complete) {
        renderCompleteState();
        if (directView) {
          if (filterInput) filterInput.placeholder = 'Search model';
          if (filterLabel) filterLabel.textContent = 'Search model';
          renderManual();
          renderOptions();
        }
        return;
      }
      var placeholder = 'Search ' + state.stage;
      if (filterInput) filterInput.placeholder = placeholder;
      if (filterLabel) filterLabel.textContent = placeholder;
      renderManual();
      if (!state.manualKind) renderOptions();
    }

    function getRideIconHtml(ride) {
      return '<span class="mobile-ride-sheet__ride-glyph" aria-hidden="true">&#xf1b9;</span>';
    }

    function renderSavedRides() {
      if (!savedList) return;
      var hasPrimaryRide = Boolean(getPrimaryRide());
      if (primaryGuide) primaryGuide.hidden = !state.rides.length || hasPrimaryRide;
      savedList.innerHTML = '';
      state.rides.map(function (ride, index) {
        return { ride: ride, index: index };
      }).sort(function (left, right) {
        if (left.ride.isCurrent !== right.ride.isCurrent) return left.ride.isCurrent ? -1 : 1;
        return left.index - right.index;
      }).forEach(function (entry) {
        var ride = entry.ride;
        var card = document.createElement('div');
        card.className = 'mobile-ride-sheet__ride-card' + (ride.isCurrent ? ' is-current' : '');
        card.tabIndex = 0;
        card.setAttribute('role', 'link');

        var icon = document.createElement('span');
        icon.className = 'mobile-ride-sheet__ride-icon';
        icon.innerHTML = getRideIconHtml(ride);

        var main = document.createElement('span');
        main.className = 'mobile-ride-sheet__ride-main' + (ride.isCurrent ? '' : ' is-compact');
        var name = document.createElement('span');
        name.className = 'mobile-ride-sheet__ride-name';
        name.textContent = [ride.year, ride.make, ride.model].filter(Boolean).join(' ');
        var nameRow = document.createElement('span');
        nameRow.className = 'mobile-ride-sheet__ride-name-row';
        if (resolvePrimaryVehicle(ride) === 1) {
          var primaryStar = document.createElement('span');
          primaryStar.className = 'mobile-ride-sheet__ride-primary-star';
          primaryStar.setAttribute('aria-label', 'Primary ride');
          primaryStar.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M7.96802 3.7915L11.7068 4.646L9.18433 7.53467L9.5271 11.354L6.00024 9.84815L2.47339 11.354L2.81616 7.53467L0.293701 4.646L4.03247 3.7915L6.00024 0.5L7.96802 3.7915Z" fill="#4B5155"/>
          </svg>
          `;
          nameRow.appendChild(primaryStar);
        }
        nameRow.appendChild(name);
        if (ride.isCurrent) {
          var status = document.createElement('span');
          status.className = 'mobile-ride-sheet__ride-top';
          status.appendChild(icon);
          var statusText = document.createElement('span');
          statusText.textContent = 'Current';
          status.appendChild(statusText);
          main.appendChild(status);
        } else {
          main.appendChild(icon);
        }
        main.appendChild(nameRow);

        var actions = document.createElement('span');
        actions.className = 'mobile-ride-sheet__ride-actions';
        var count = document.createElement('span');
        count.className = 'mobile-ride-sheet__ride-count';
        if (ride.itemsCount !== '') count.textContent = String(ride.itemsCount) + ' items';

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'mobile-ride-sheet__ride-remove';
        remove.setAttribute('aria-label', 'Remove ' + name.textContent);
        remove.innerHTML = '<svg class="mobile-ride-sheet__ride-remove-glyph" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4.66667 6h6.66666l-.56813 7.3333H5.23485L4.66667 6Z"/><path d="M3.33333 4.66667h9.33337M6.41739 3.33333h3.16522"/><path d="M7.03337 7.63333V11.5M8.9667 7.63333V11.5"/></svg>';
        actions.appendChild(count);
        actions.appendChild(remove);

        function activateRide() {
          var sequence = ++navigationRequestSequence;
          var reloadProductPage = shouldReloadProductAfterRideSave();
          syncLocalRide(ride, ride.id);
          var update = isLoggedIn && hasRemoteRideId(ride) ? updateCurrentRide(ride.id) : Promise.resolve(null);
          update.finally(function () {
            if (!isDestroyed && sequence === navigationRequestSequence) {
              navigateAfterSave(ride, undefined, undefined, undefined, {
                reloadProductPage: reloadProductPage
              });
            }
          });
        }

        remove.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          removeRide(ride);
        });
        card.addEventListener('click', activateRide);
        card.addEventListener('keydown', function (event) {
          if (event.target !== card) return;
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          activateRide();
        });
        card.appendChild(main);
        card.appendChild(actions);
        savedList.appendChild(card);
      });
    }

    function deleteRideFromApi(ride) {
      if (!isLoggedIn || !deleteUrl || !hasRemoteRideId(ride)) return Promise.resolve(true);
      var formData = new FormData();
      formData.append('id', ride.id);
      return fetchWithTimeout(deleteUrl, {
        method: 'DELETE',
        credentials: 'include',
        body: formData
      }, REQUEST_TIMEOUT_MS).then(function (response) {
        return response.ok;
      }).catch(function () {
        return false;
      });
    }

    function removeRide(ride) {
      if (typeof window.KMTrackVehicleEvent === 'function') {
        window.KMTrackVehicleEvent('remove_saved_vehicle', {
          ymm: [ride.year, ride.make, ride.model].filter(Boolean).join(' ')
        });
      }
      deleteRideFromApi(ride);
      var key = rideIdentity(ride);
      state.rides = state.rides.filter(function (savedRide) { return rideIdentity(savedRide) !== key; });
      writeLocalRides(state.rides);
      setCurrentLabel(currentRide());
      if (!state.rides.length) {
        resetDraft();
        state.stage = 'year';
        render();
        ensureYears();
        return;
      }
      render();
    }

    function clearSubscriptionError() {
      if (subscriptionError) subscriptionError.hidden = true;
      if (subscriptionEmail) subscriptionEmail.setAttribute('aria-invalid', 'false');
    }

    function showSubscriptionError(message, invalidEmail) {
      if (subscriptionError) {
        subscriptionError.textContent = String(message || 'Unable to save. Please try again.');
        subscriptionError.hidden = false;
      }
      if (subscriptionEmail) {
        subscriptionEmail.setAttribute('aria-invalid', invalidEmail ? 'true' : 'false');
      }
    }

    function handleSubscriptionSubmit(event) {
      event.preventDefault();
      if (state.countLoading || state.submitting) return;
      var email = String(subscriptionEmail ? subscriptionEmail.value : '').trim();
      if (!validEmail(email)) {
        showSubscriptionError('Please enter a valid email address.', true);
        if (subscriptionEmail) {
          subscriptionEmail.focus();
        }
        return;
      }
      clearSubscriptionError();
      var ride = recordEmailBinding('bound', email, buildRideFromSelection());
      saveAndNavigate(ride, 'request', true, subscribeButton);
    }

    function handleNotNow(event) {
      event.preventDefault();
      if (state.countLoading || state.submitting) return;
      addCustomerTag('ride_updates_skip_click');
      var ride = recordEmailBinding('unbound', '', buildRideFromSelection());
      saveAndNavigate(ride, 'subscribe', false, notNowLink);
    }

    function trackTopSearch(payload, ride) {
      if (typeof window.KMBuildDataTrackPayload === 'function') {
        payload = window.KMBuildDataTrackPayload(payload);
      }
      var eventTracking;
      if (typeof window.KMTrackGaEventAsync === 'function') {
        eventTracking = window.KMTrackGaEventAsync('click_vehicle_search', payload, undefined, {
          timeout: 800,
          transport: 'beacon'
        });
      } else if (typeof window.KMTrackGaEvent === 'function') {
        window.KMTrackGaEvent('click_vehicle_search', payload);
        eventTracking = Promise.resolve(true);
      } else if (typeof window.gtag === 'function') {
        window.gtag('event', 'click_vehicle_search', payload);
        eventTracking = Promise.resolve(true);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({
          event: 'click_vehicle_search'
        }, payload));
        eventTracking = Promise.resolve(true);
      }
      return Promise.all([
        Promise.resolve(eventTracking).catch(function () { return false; }),
        waitForCustomerTag(addGarageSearchCustomerTag(ride))
      ]);
    }

    function getRideForTopSearch() {
      var activeRide = currentRide();
      if (activeRide) return activeRide;
      if (isShopWithoutRideActive()) return null;
      var localRide = readLocalRides().find(function (ride) {
        return ride && ride.isCurrent;
      });
      return localRide || getRideFromUrl();
    }

    function handleTopSearch(event) {
      if (event) event.preventDefault();
      var ride = getRideForTopSearch() || {};
      var keyword = keywordInput ? String(keywordInput.value || '').trim() : '';
      var payload = { search_query: keyword, search_source: 'pdp_top_input' };
      var tracking = withTimeout(trackTopSearch(payload, ride), TRACKING_TIMEOUT_MS).catch(function () {
        return false;
      });
      tracking.finally(function () { window.location.href = buildSearchUrl(ride, keyword); });
    }

    function handleShopWithoutRide(event) {
      event.preventDefault();
      setShopWithoutRideTooltipVisible(false);
      var targetUrl = shopWithoutRideLink.getAttribute('href') || redirectUrl;
      setShopWithoutRideActive(true);
      state.rides = state.rides.map(function (ride) { return Object.assign({}, ride, { isCurrent: false }); });
      writeLocalRides(state.rides);
      setCurrentLabel(null);
      var clearOperation = typeof window.KMClearGarageCurrentRide === 'function'
        ? window.KMClearGarageCurrentRide({ syncRemote: true })
        : (isLoggedIn && resetUrl ? fetchWithTimeout(resetUrl, {
            method: 'POST',
            credentials: 'include',
            keepalive: true,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userId: customerId, email: customerEmail || '' })
          }, REQUEST_TIMEOUT_MS).catch(function () { return null; }) : Promise.resolve(null));
      var clearPromise = withTimeout(Promise.resolve(clearOperation), REQUEST_TIMEOUT_MS).catch(function () {
        return null;
      });
      var tracking = typeof window.KMTrackGaEventAsync === 'function'
        ? window.KMTrackGaEventAsync('click_shop_without_ride', { ui_location: 'garage_modal' }, undefined, { timeout: 800, transport: 'beacon' })
        : Promise.resolve(false);
      tracking = withTimeout(Promise.resolve(tracking), TRACKING_TIMEOUT_MS).catch(function () {
        return false;
      });
      clearPromise.finally(function () {
        tracking.finally(function () { window.location.href = targetUrl; });
      });
    }

    function loadInitialData() {
      refreshRidesFromStorage();
      state.stage = state.rides.length ? 'saved' : 'year';
      ensureYears();
      if (!isLoggedIn) {
        state.garageReady = true;
        render();
        if (ridePromptController) ridePromptController.setGarageReady();
        return;
      }
      fetchGarage().then(function (remoteRides) {
        if (isDestroyed) return;
        var localRides = readLocalRides();
        state.rides = garageRequestSucceeded
          ? replaceRidesWithRemote(remoteRides, localRides)
          : localRides;
        if (isShopWithoutRideActive()) {
          state.rides = state.rides.map(function (ride) {
            return Object.assign({}, ride, { isCurrent: false });
          });
        }
        writeLocalRides(state.rides);
        resetDraft();
        state.stage = state.rides.length ? 'saved' : 'year';
        state.garageReady = true;
        setCurrentLabel(currentRide());
        if (ridePromptController) ridePromptController.setGarageReady();
        if (state.stage === 'year') ensureYears();
        else render();
      });
    }

    function handleRideStorageChange(event) {
      if (isDestroyed) return;
      var detail = event && event.detail;
      if (!detail || detail.storageKey !== storageKey || detail.source === root) return;
      if (isLoggedIn && garageRequestSucceeded) return;
      var wasSavedStage = state.stage === 'saved';
      refreshRidesFromStorage();
      if (!state.garageReady) {
        render();
        return;
      }
      if (wasSavedStage && !state.rides.length) {
        resetDraft();
        state.stage = 'year';
        render();
        ensureYears();
        return;
      }
      render();
    }

    function destroy() {
      if (isDestroyed) return;
      isDestroyed = true;
      var wasOpen = sheet.classList.contains('is-open');
      if (ridePromptController) ridePromptController.destroy();
      cancelPendingTransition();
      window.clearTimeout(popupHideTimer);
      popupHideTimer = 0;
      makeRequestSequence += 1;
      modelRequestSequence += 1;
      countRequestSequence += 1;
      navigationRequestSequence += 1;
      document.removeEventListener('km:mobile-ride-storage-change', handleRideStorageChange);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
      document.removeEventListener('click', handleShopWithoutRideTooltipOutside);
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      if (sheet.parentNode) sheet.parentNode.removeChild(sheet);
      var hasOpenSheet = Boolean(document.querySelector('[data-mobile-ride-sheet].is-open'));
      document.body.classList.toggle('mobile-ride-sheet-open', hasOpenSheet);
      if (wasOpen && !hasOpenSheet) endGarageTagFlow();
      if (hasOpenSheet) hideThirdPartyPopups();
      else restoreThirdPartyPopups();
      delete sheet.__kmMobileRideOwner;
      delete root.__kmMobileRideSheet;
      delete root.__kmMobileRideController;
      delete root.__kmMobileRideCleanup;
      delete root.__kmMobileRideCriticalReady;
      root.removeAttribute('data-mobile-ride-inited');
      root.removeAttribute('data-mobile-ride-ready');
    }

    function handleSectionUnload(event) {
      var section = event && event.target;
      if (!section) return;
      if (section === root || (typeof section.contains === 'function' && section.contains(root))) destroy();
    }

    openButton.addEventListener('click', function (event) {
      setFitCartEntry(openButton.getAttribute('data-fit-cart-open-request') === 'true');
      addGarageEntryClickCustomerTag(event);
      if (event && event.isTrusted && typeof window.KMSetVehicleEntrySource === 'function') {
        window.KMSetVehicleEntrySource('header_nav');
      }
      if (typeof window.KMTrackVehicleEntryClick === 'function') window.KMTrackVehicleEntryClick('header_nav');
      openSheet();
    });
    closeButtons.forEach(function (button) { button.addEventListener('click', closeSheet); });
    if (addButton) addButton.addEventListener('click', openAdd);
    if (backButton) backButton.addEventListener('click', function () { showStage('saved'); });
    if (primaryOpen) primaryOpen.addEventListener('click', openPrimaryRide);
    if (primaryChange) primaryChange.addEventListener('click', openPrimaryRide);
    if (primarySkip) primarySkip.addEventListener('click', function () { showStage('saved'); });
    if (primarySave) primarySave.addEventListener('click', savePrimaryRide);
    if (primarySubscriptionForm) primarySubscriptionForm.addEventListener('submit', savePrimaryRide);
    if (primaryEmail) primaryEmail.addEventListener('input', clearPrimaryError);
    if (primaryDiscountCopy) primaryDiscountCopy.addEventListener('click', function () {
      if (!state.primaryDiscountCode || !navigator.clipboard) return;
      navigator.clipboard.writeText(state.primaryDiscountCode).then(function () {
        primaryDiscountCopy.textContent = 'Copied';
      });
    });
    if (shopWithoutRideLink) shopWithoutRideLink.addEventListener('click', handleShopWithoutRide);
    if (shopWithoutRideTooltip && shopWithoutRideTooltipTrigger) {
      shopWithoutRideTooltipTrigger.addEventListener('click', handleShopWithoutRideTooltip);
      document.addEventListener('click', handleShopWithoutRideTooltipOutside);
    }
    if (filterInput) filterInput.addEventListener('input', function () {
      state.filter = String(filterInput.value || '').trim();
      renderOptions();
    });
    if (manualInput) manualInput.addEventListener('input', function () {
      if (manualError) manualError.hidden = true;
    });
    if (manualInput) manualInput.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      handleManualContinue();
    });
    if (manualContinue) manualContinue.addEventListener('click', handleManualContinue);
    stepButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var targetStage = button.getAttribute('data-mobile-step');
        if (button.disabled) return;
        showStage(targetStage);
        if (targetStage === 'model' && state.selected.isCustom) {
          state.manualKind = 'model';
          if (manualInput) manualInput.value = state.selected.model || '';
          render();
        }
      });
    });
    if (viewItemsButton) viewItemsButton.addEventListener('click', function () {
      var ride = buildRideFromSelection();
      var vehicleSave = getTrackingVehicleValue(ride);
      var trackingOptions = vehicleSave
        ? { globalPayload: { vehicle_save: vehicleSave } }
        : undefined;
      saveAndNavigate(ride, 'request', false, viewItemsButton, trackingOptions);
    });
    if (subscriptionForm) subscriptionForm.addEventListener('submit', handleSubscriptionSubmit);
    if (subscribeButton) subscribeButton.addEventListener('click', handleSubscriptionSubmit);
    if (subscriptionEmail) {
      subscriptionEmail.addEventListener('focus', dismissSubscriptionEmailPrompt);
      subscriptionEmail.addEventListener('input', clearSubscriptionError);
    }
    if (notNowLink) notNowLink.addEventListener('click', handleNotNow);
    if (keywordInput) keywordInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') handleTopSearch(event);
    });
    if (searchButton) searchButton.addEventListener('click', handleTopSearch);
    document.addEventListener('km:mobile-ride-storage-change', handleRideStorageChange);
    document.addEventListener('shopify:section:unload', handleSectionUnload);

    if (typeof window.KMCreateRidePickerPromptController === 'function') {
      ridePromptController = window.KMCreateRidePickerPromptController(root, {
        canConfirmNoSelectedRide: function () {
          if (isLoggedIn) return garageRequestSucceeded;
          return readLocalRidesSnapshot().ok;
        },
        hasSelectedRide: function () {
          var hasSavedRide = state.rides.some(function (ride) {
            if (!ride) return false;
            var hasCompleteYmm = Boolean(ride.year && ride.make && ride.model);
            return Boolean(ride.id || hasCompleteYmm);
          });
          if (hasSavedRide) return true;

          var localRides = readLocalRides();
          var hasLocalRide = localRides.some(function (ride) {
            if (!ride) return false;
            var hasCompleteYmm = Boolean(ride.year && ride.make && ride.model);
            return Boolean(ride.id || hasCompleteYmm);
          });
          if (hasLocalRide) return true;

          var runtimeRide = getRideFromUrl();
          return Boolean(runtimeRide && runtimeRide.year && runtimeRide.make && runtimeRide.model);
        },
        openMobilePicker: function () {
          openButton.click();
        }
      });
    }

    root.__kmMobileRideController = { openAdd: openAdd, openSheet: openSheet, closeSheet: closeSheet, destroy: destroy };
    root.__kmMobileRideCleanup = destroy;
    var params = new URLSearchParams(window.location.search);
    if (keywordInput && params.get('title')) keywordInput.value = params.get('title');
    root.setAttribute('data-mobile-ride-ready', 'true');
    loadInitialData();
    if (sheet.classList.contains('is-open')) openSheet();
  }

  function init() {
    document.querySelectorAll('[data-mobile-ride-entry]').forEach(setup);
    if (document.__kmMobileRideExternalBound) return;
    document.__kmMobileRideExternalBound = true;
    document.addEventListener('click', function (event) {
      var trigger = event.target && typeof event.target.closest === 'function'
        ? event.target.closest('[data-mobile-ride-open-external], [data-drawer-vehicle-trigger]')
        : null;
      if (!trigger) return;
      event.preventDefault();
      var roots = Array.prototype.slice.call(document.querySelectorAll('[data-mobile-ride-entry]'));
      var drawerContext = trigger.closest('[data-drawer-new], #NavDrawerNew');
      var targetRoot = drawerContext ? drawerContext.querySelector('[data-mobile-ride-entry]') : null;
      if (!targetRoot && trigger.hasAttribute('data-mobile-ride-open-external')) {
        var pageContext = trigger.closest('main');
        if (pageContext) {
          targetRoot = roots.find(function (entry) {
            return entry.getAttribute('data-stay-on-page') === 'true' && pageContext.contains(entry);
          }) || null;
        }
        if (!targetRoot) {
          targetRoot = roots.find(function (entry) {
            return entry.getAttribute('data-stay-on-page') === 'true';
          }) || null;
        }
      }
      if (!targetRoot) {
        var sectionContext = trigger.closest('.shopify-section');
        targetRoot = sectionContext ? sectionContext.querySelector('[data-mobile-ride-entry]') : null;
      }
      if (!targetRoot) targetRoot = roots.find(isVisibleEntry) || roots[0];
      if (!targetRoot || !targetRoot.__kmMobileRideController) return;
      targetRoot.removeAttribute('data-fit-cart-entry');
      if (event.isTrusted && typeof window.KMSetVehicleEntrySource === 'function') {
        window.KMSetVehicleEntrySource('header_nav');
      }
      if (typeof window.KMTrackVehicleEntryClick === 'function') window.KMTrackVehicleEntryClick('header_nav');
      targetRoot.__kmMobileRideController.openSheet();
    });
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
